import React from 'react';
import Input from "@material-ui/core/Input";
import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import history from '../../history';
import {globs, constant, timedOut,getRandomString,saveLocalStorage,saveLocalStorage2,
  getLocalStorage,getTime,callStack,ufs,uncompress,az,
  proportionals800,showTime,
  isHydrorootFwAtLeast,

} from '../../components/utils/utils';

import {dbVals,getZoneControllers, sendArray} from '../../components/utils/http'
import {loadSensorsInfo,getSensorsZone,loadZonesInfo,getZoneInfo,loadSiteData,
  intToBase64,getRangeFromValue,genSensorTypeUnits,makeGenSensorTypeUnits,
  getIrrAccLiteThresh,
} from '../components/C18utils'
import {p, pi, pInd, dpNames, tableBases2} from '../../components/utils/paramIds'
import{setClientId,updateSyncStat} from '../../components/utils/ws'

// firmware "no sensor connected" sentinels, see pearl shared/Legacy/Inc/Global.h
// generic sensors use a higher value because valid readings can exceed 10000
var SENSOR_ERR_VAL=10000
var GEN_SENSOR_ERR_VAL=1000000

var isSensorErrVal=(val,isGeneric)=>{// true if the sensor is reporting "not connected"
// generic sensors send 1000000 on new firmware, 10000 on older firmware
  let v=+val
  return((v==SENSOR_ERR_VAL)||(isGeneric&&(v==GEN_SENSOR_ERR_VAL)))
}

var isGenSensorPid=(pid)=>{// pid is inside the generic sensor status table
  let tab=pInd[1900]?.pearl_gen_sens_stat||[]
  let base=+tab[0]
  return((+pid>=base)&&(+pid<base+(tab[2]||4)*(tab[3]||128)))
}
// import {config} from '../../components/utils/config'

var cl = console.log
var cl2=async(...args)=>{
//   console.log(args)
  await wsTrans("usa", {cmd: "cRest", uri: "/s/reactLog", method: "update",
    sessionId: globs.userData.session.sessionId,
    body: args})
}
var config = require('../../components/utils/config');
config = config.default || config;
//     cl((config))
// var globs = {};
// var constant = {// must be taken from main utils!
//   urls: {
//     usa: "http://ng.c2.link4cloud.com/usa",
//     auth: "http://userAuth.c2.link4cloud.com",
//     email: "http://email.c2.link4cloud.com"
//   },
//   reCaptchaKeys: {// these are v3 keys, from 20200915, for Link4Cloud@GMail.com
//     site_v2:   "6LergcwZAAAAAEZu1hJC5b7s8ar2JSHvgyfgbYpx",
//     secret_v2: "6LergcwZAAAAABXOadtCvKVoPCfP3AibSWRVVzhQ",
//     site_v3:   "6Lesf8wZAAAAAA-PzVShQGJX3eoHvT5voGznNKIG",
//     secret_v3: "6Lesf8wZAAAAAAUmHQvGxMg6g2nS8w9GlP6woXCy",
//   },
// };
var cl=console.log;

/*
These are the v3 Recaptcha Keys for Link4Cloud@GMail.com, from 20200915:

site:   6Lesf8wZAAAAAA-PzVShQGJX3eoHvT5voGznNKIG
secret: 6Lesf8wZAAAAAAUmHQvGxMg6g2nS8w9GlP6woXCy
 */

/********************** values and functions for Widgets **********************************/

//             HUMDEHUM_NORM = new HumidityStage("HUMDEHUM_NORM", 0, "Normal", "Normal");
//             HUMIDIFY = new HumidityStage("HUMIDIFY", 1, "Humidify", "Humidify");
//             DEHUMIDIFY_1 = new HumidityStage("DEHUMIDIFY_1", 2, "Dehumidify 1", "Dehum1");
//             DEHUMIDIFY_2 = new HumidityStage("DEHUMIDIFY_2", 3, "Dehumidify 2", "Dehum2");
//             DEHUMIDIFY_LOWTEMP = new HumidityStage("DEHUMIDIFY_LOWTEMP", 4, "Dehumidify Low Temperature", "DehumLT");


var stages=["Heat 6", "Heat 5", "Heat 4", "Heat 3", "Heat 2", "Heat 1", "Normal", 
"Cool 1", "Cool 2", "Cool 3", "Cool 4", "Cool 5", "Cool 6" ]
var humStages=["Normal","Humidify","DeHumidify 1","DeHumidify 2",
"DH LowTmp"]
var eqTypes=["None", "On Off", "Irr", "Co2", "HID", "Mzone", "Pump", "Fvalve", "Vent", "Curt", "MixV", "MZone2", 
"GenPid", "None", "None", "None", "None", "None", "VarOut"]

var getTable=(pid,z)=>{
  let zType=(globs.siteZoneTypes||{})[z]||1800
  for (let i = 0 ; i < (tableBases2[zType]||[]).length - 1 ; i++){
    if(pid < tableBases2[zType][i+1][0]){
      return tableBases2[zType][i]
    }
  }
}

var pctUnit=(z)=>{
  return {t:"%",v:0}
}

var co2Unit=(z)=>{
  return {t:"PPM",v:0}
}

var nulUnit=(z)=>{
  return {t:"",v:0}
}

var pressUnit=(z)=>{
  return {t:"kPa",v:0}
}

var getZoneGwType=(zInd)=>{
  let siteId=globs.userData.siteLoaded
  return (globs.zonesInfo.sz2z[siteId]||{})[zInd]?.gatewayType
}

var tempUnit=(z)=>{
//   cl(z)
  var pid,chan,map
  if(getZoneGwType(z)==800){
    pid=getParamId800("igC","temperatureUnits")
    chan=240
  }else{
    pid=getParamId("configuration_zone_settings","Temperature Units")
    chan=255// this seems wrong
  }
  let unit=(dbVals.z[z]&&dbVals.z[z][chan])?+(dbVals.z[z][chan][pid]||0):0
  let ret={t:(unit)?"\u00B0C":"\u00B0F",v:unit}
//   cl(ret)
  return ret
}

var windUnit=(z)=>{
  let pid=getParamId("configuration_zone_settings","Windspeed Units")
  let unit=(dbVals.z[z]&&dbVals.z[z][255])?+(dbVals.z[z][255][pid]||0):0
//   let unit=(dbVals.z[z])?+(dbVals.z[z][255][pid]||0):0
//   let unit=+(dbVals.z[z][255][pid]||0)
  return {t:(unit)?"kph":"mph",v:unit}
}

var lightUnit=(z)=>{
  let pid=getParamId("configuration_zone_settings","Light Units")
  let unit=(dbVals.z[z]&&dbVals.z[z][255])?+(dbVals.z[z][255][pid]||0):0
//   let unit=(dbVals.z[z])?+(dbVals.z[z][255][pid]||0):0
//   let unit=+(dbVals.z[z][255][pid]||0)
  return {t:["w/m\u00B2","kLux","uMol/m\u00B2/s"][unit],v:unit}
//   return {t:(unit)?"uMol/m\u00B2/s":"w/m\u00B2",v:unit}
}

var cumLightUnit=(z)=>{
  let pid=getParamId("configuration_zone_settings","Light Units")
  let unit=(dbVals.z[z]&&dbVals.z[z][255])?+(dbVals.z[z][255][pid]||0):0
  return {t:["kwh","kLux","Mol/m\u00B2"][unit],v:unit}
}

var nuteUnit=(z)=>{
  let pid=getParamId("configuration_zone_settings","Nutrient Units")

  let unit=(dbVals.z[z]&&dbVals.z[z][255])?+(dbVals.z[z][255][pid]||0):0
//   let unit=(dbVals.z[z])?+(dbVals.z[z][255][pid]||0):0
//   let unit=+(dbVals.z[z][255][pid]||0)
  return {t:["us","CF","PPM"][unit],v:unit}
}

var bVolUnit=(z)=>{// "big" volume
  let pid=getParamId("configuration_zone_settings","Volume Measurement Units")
  let unit=(dbVals.z[z]&&dbVals.z[z][255])?+(dbVals.z[z][255][pid]||0):0
//   let unit=(dbVals.z[z])?+(dbVals.z[z][255][pid]||0):0
//   let unit=+(dbVals.z[z][255][pid]||0)
  return {t:["gal","l","gal"][unit],v:unit}
}

var sVolUnit=(z)=>{// "small" volume
  let pid=getParamId("configuration_zone_settings","Volume Measurement Units")
  let unit=(dbVals.z[z]&&dbVals.z[z][255])?+(dbVals.z[z][255][pid]||0):0
//   let unit=(dbVals.z[z])?+(dbVals.z[z][255][pid]||0):0
//   let unit=+(dbVals.z[z][255][pid]||0)
  return {t:["oz","ml","ml"][unit],v:unit}
}

var voltUnit=(z)=>{// voltage
  // let pid=getParamId("configuration_zone_settings","Volume Measurement Units")
  // let unit=(dbVals.z[z]&&dbVals.z[z][255])?+(dbVals.z[z][255][pid]||0):0
//   let unit=(dbVals.z[z])?+(dbVals.z[z][255][pid]||0):0
//   let unit=+(dbVals.z[z][255][pid]||0)
  return {t:["V"][0],v:0}
}

var doUnit=(z)=>{
  return {t:["mg/Ltr"][0],v:0}
}

var flowUnit=(z)=>{
  return {t:["gpm"][0],v:0}
}

var distUnit=(z)=>{
  return {t:["gal"][0],v:0}
}

var getParamId2=(gwType,table, column)=>{// this is not handling indexes!
    let fieldName=dpNames[table]||table
//     if(table=="pearl_xb_snaps"){cl(fieldName)}
//     cl(gwType)
      // cl(gwType, fieldName,)
    let type = pInd ? pInd[gwType] ? pInd[gwType][fieldName] : pInd[gwType] : pInd
//     if((fieldName=="pearl_snaps")&&(gwType==1800)){cl(gwType,fieldName)}
    // cl(pInd[gwType])
//     if(table=="pearl_xb_snaps"){cl(type)}
    // cl(fieldName,gwType,column)
    let pid = (pi ? pi[gwType] ? pi[gwType][fieldName] : pi[gwType] : pi||{}) ?
        (pi ? pi[gwType] ? pi[gwType][fieldName] : pi[gwType] : pi||{})[column] : 
        (pi ? pi[gwType] ? pi[gwType][fieldName] : pi[gwType] : pi||{})
//     cl(fieldName)
//     if(table=="configuration_channel_data"){
//       cl(fieldName)
//       cl(pi[1800][fieldName])
        // cl(pid)
//     }
//     cl(pid)
//     if(column=="CD_analog_min_varout"){cl([fieldName,type,column,pid])}
    var dp
    if (type) {
      switch(type[1]){
        case 6:// zone and unit config
        case 7:// zone and unit config
          pid=2*pid+1
          break
        default:
          break
      }
      switch(type[1]){
        default:
          dp=pid+type[0]
          break
      }
    }
    return dp
  }

var getParamId800=(ta,co)=>{
//   cl(ta,co)
  return pi[800][ta][co]+pInd[800][ta][0]
}
  
var getParamId=(table, column)=>{// this is not handling indexes!
  return getParamId2(1800,table,column)
//     let fieldName=dpNames[table]
// //     cl(fieldName)
//     let type = pInd[1800][fieldName]
// //     cl(fieldName)
//     let pid = pi[1800][fieldName][column]
// //     if(table=="configuration_channel_data"){
// //       cl(fieldName)
// //       cl(pi[1800][fieldName])
// //         cl(pid)
// //     }
// //     cl(pid)
// //     if(column=="CD_analog_min_varout"){cl([fieldName,type,column,pid])}
//     
//     switch(type[1]){
//       case 6:// zone and unit config
//       case 7:// zone and unit config
//         pid=2*pid+1
//         break
//       default:
//         break
//     }
//     var dp
//     switch(type[1]){
//       default:
//         dp=pid+type[0]
//         break
//     }
//     return dp
  }
  
//   var alarmToSensor={ITHi:"inT",ITHi:"inT",ITSn:"inT",}
  var alarmToSensor=(alarmId)=>{
    let len=alarmId.length
    if(alarmId.substring(len-2,len)=="Sa"){
      return alarmId.substring(0,5)
    }
  }
  
  var sensorIds
  var siteSensorNames
  
  var fixSensorIds=(zInd)=>{// extends ids to include expansion controllers
//     /*console.trace*/()
    let zoneControllers=getZoneControllers(zInd)
//     cl(zoneControllers)
//     cl(sensorIds)
    Object.keys(sensorIds).forEach(sid=>{
//       cl(sid)
      for(let i=1;i<4;i++){
        if(+zoneControllers[i]){
          sensorIds[`e${i}${sid}`]=Object.assign({},sensorIds[sid])
          
        }
      }
//       cl(sid)
      if(!["e0","e1","e2","e3"].includes(sid.substring(0,2))){
        sensorIds[`e0${sid}`]=sensorIds[sid]
        delete sensorIds[sid]
      }
    })
//     cl(sensorIds)
  }
  
  var makeSiteSensorNames=async(siteId)=>{
// use the sensorIds to make a complete list of all sensor names
// for all zones on the site, organized by zoneId
// then *erase* sensorIds
//     cl(siteId)
// this is trashing the current sensorIds
    await loadSiteData(siteId)
    await loadZonesInfo()
//     cl(sensorIds.e0at0.name)
    let gzi=globs.zonesInfo.info
//     cl(gzi)
    siteSensorNames={}
    for(let i=0;i<gzi.length;i++){
      let z=gzi[i]
//       z.inNet=true// just for testing
//       cl(z)
      if((z.siteId==siteId)&&(z.inNet)||(z.controllerId)){
        // cl(z)
//         cl(z)
        initSensorIds(z.siteZoneIndex,z.zoneId,z.gatewayType)
        await setSensorIdNames(z.zoneId)
//         cl(sensorIds)
        let sensorNames={}
        Object.keys(sensorIds).forEach(k=>{sensorNames[k]={name:sensorIds[k].name}})
        siteSensorNames[z.zoneId]=sensorNames
        siteSensorNames[z.siteZoneIndex]=sensorNames
      }
    }
//     cl(sensorIds.e0at0.name)
//     sensorIds=null
//     cl(siteSensorNames)
    return siteSensorNames
  }
  
  var loadAddedSensors=(zInd)=>{
//     console.trace()
    let asNames={temp:"Temperature",hum:"Humidity"}
    let valId=getParamId("config_added_sensors","value")
    let typeId=getParamId("config_added_sensors","type")
    let unitId=getParamId("config_added_sensors","unit")
    let addSensors=[]
    for(let i=0;i<40;i++){
//       cl(zInd,i,valId)
//       cl([zInd,i,valId])
       if(((dbVals.z[zInd]||{})[i]||{})[valId]){
//          cl((dbVals.z[zInd][i]||{})[valId])
         let type=dbVals.z[zInd][i][typeId]||""
         let unit=dbVals.z[zInd][i][unitId]||""
//          cl([zInd,i,unitId,unit])
         let pos=unit.lastIndexOf("x")
         let mult=1
         if(pos>0){mult=+unit.substring(pos+1)}
//          cl(mult)
         addSensors.push({
           ch:i,
           name:`AS ${asNames[type]}`,
           type:type,
           unit:dbVals.z[zInd][i][unitId],
           mult:mult,
           id:valId,
        })}
    }
    return addSensors
  }
  
  var initAddedSensors=(zInd)=>{
    let addSensors=loadAddedSensors(zInd)
//     cl(addSensors)
    addSensors.forEach(s=>{
      let id=`e0as${s.ch}`
      sensorIds[id]={
        ch:s.ch,
        sensorIndex:s.ch+60,
        name:s.name,
        unit:s.unit,
        mult:s.mult,
        name2:"",
        id:s.id,
        type:"addedSensor",
      }
    })

    
//     cl(sensorIds)
// {
//     "ch": 240,
//     "id": 33,
//     "map": 4233,
//     "cal": 4295,
//     "lcIndex": 4,
//     "sensorIndex": 6,
//     "name": "Outside Light",
//     "name2": ""
// }    
//   let pid=getParamId("config_added_sensors","value")
//   cl(pid)
  
  }
  
  var initMBRegisters=(zInd,zoneId)=>{
    if(!zoneId){return}
//     cl("add mb registers")
//     cl(zInd)
//     cl(zoneId)
//     cl(globs.mbInfo.info)
//     cl(globs.zonesInfo.info)
    let zone=globs.zonesInfo.info.filter(z=>{return z.zoneId==zoneId})[0]
    let mbDevs=globs.mbInfo.info.devices.filter(d=>{
      return (d.gatewayId==zone?.gatewayId)&&(d.zone==zone?.siteZoneIndex)})
    let mbRegs=[]
    mbDevs.forEach(d=>{
      let addRegs=globs.mbInfo.info.registers.filter(r=>{
        return (r.gatewayId==zone.gatewayId)&&(r.typeId==d.typeId)}).map(r=>{return{
          regAddr:r.addr,
          typeId:r.typeId,
          mbAddr:d.addr,
          dName:d.name,
          rName:r.name,
        }})
//       cl(addRegs)
      mbRegs=mbRegs.concat(addRegs)
    })
//     cl(mbDevs)
//     cl(zone)
//     cl(mbRegs)
    Object.keys(mbRegs).forEach(k=>{
      let r=mbRegs[k]
//       cl(r)
      let addr=(zInd<<24)|(r.mbAddr<<16)|(r.regAddr)
      let id=`e0MB${intToBase64(addr)}`
//       cl(id)
      let name=`${r.dName}-${r.rName}`
      sensorIds[id]={
        z:zInd+64,
        ch:r.mbAddr,//s.ch,
        pid:r.regAddr,
//         sensorIndex:s.ch+60,
        name:name,
        unit:nulUnit,
        mult:1,
        name2:"",
        id:r.regAddr,
        type:"mbPoint",
      }
    })
//     mbRegs.forEach(r=>{
//     })
//       let id=`e0as${s.ch}`
//       sensorIds[id]={
//         ch:s.ch,
//         sensorIndex:s.ch+60,
//         name:s.name,
//         unit:s.unit,
//         mult:s.mult,
//         name2:"",
//         id:s.id,
//         type:"addedSensor",
//       }
//   cl(sensorIds)
  }

  var addAuxSensors=(sensorIds,zInd)=>{
    let types=[
      {
        snTab:"snapshot_aux_alarms",
        snCol:"alarmValue",
        cnTab:"config_aux_alarms",
        nmCol:"alarmName",
        cnt:32,
        snNm:"aa",
        name:"Aux Alarm ",
        def:[[0,1]],
      },
      {
        snTab:"snapshot_aux_persistent_variables",
        snCol:"variableValue",
        cnTab:"config_aux_persistent_variables",
        nmCol:"variableName",
        cnt:32,
        snNm:"ap",
        name:"Aux PVar ",
        def:[[0,100]],
      },
      {
        snTab:"snapshot_aux_variables",
        snCol:"variableValue",
        cnTab:"config_aux_variables",
        nmCol:"variableName",
        cnt:64,
        snNm:"av",
        name:"Aux Var ",
        def:[[0,100]],
      },
    ]
    types.forEach(ty=>{
      for(let i=0;i<ty.cnt;i++){
        // Guard: dbVals for this zone/channel may not be loaded yet when
        // makeSiteSensorNames iterates all zones in a site. Without this
        // check, getDbVal throws "Cannot read properties of undefined".
        let customName=(((dbVals.z||{})[zInd]||{})[240])
          ?getDbVal(ty.cnTab,ty.nmCol,zInd,240,i)
          :null
        let fields={
          id:getDbId(ty.snTab,ty.snCol,i),
          ch:240,
          name:(customName!=null&&String(customName).trim()!=="")
            ?String(customName).trim()
            :`${ty.name}${i}`,
          default:ty.def,
          unit: nulUnit,
//           unitGroup:(ty.snName=="aa")?"On/Off":"",
        }
//         cl(`e0${ty.snNm}${i}`)
//         cl(fields)
        sensorIds[`e0${ty.snNm}${i}`]=fields
      }
    })
//     cl(sensorIds)
  }

  var addGSensors=(sensorIds)=>{
    let pgss="pearl_gen_sens_stat"
    let base=getParamId2(1900,pgss,"adjValue")
      let gn0={ch: 240, id: base,
        map:getParamId2(1900,"pearl_gen_sens_conf","mapping"),
        cal:getParamId2(1900,"pearl_gen_sens_conf","calibrate"),
        lcIndex:77,
        sensorIndex:58,
        name:"Generic Sensor 1", name2:"",  unit: pctUnit, unitGroup:"Saturation", default: [[0, 100]]}
      let tab=pInd[1900][pgss]
      let mult=tab[2]
      let cnt=tab[3]
//       cl(tab)
//       cl(base, tab)

      Object.keys([...Array(128)]).forEach(k=>{
//         cl(k)
        let i=+k
        let fields={
          lcIndex:77+i,// 77 - 204
          id:base+i*mult,
          sensorIndex:58+i,// 58 - 185
          name:`Generic Sensor ${i+1}`,
        }
        let gnx=Object.assign({},gn0,fields)
        sensorIds[`e0gn${i}`]=gnx
      })
//       cl(sensorIds)
  }

  var addVpdDli=(zInd,sensorIds)=>{
// add sensors for configured vpd and dli channels: e0c00vpd
//     cl("add vpd")
//     let accVpdThreshId=getParamId2(1900,"configuration_channel_data",
//       "vpdacc_threshold")
    let ids={
      eqTypeId:getParamId2(1900,"configuration_channels","channelType"),
      eqNameId:getParamId2(1900,"configuration_channels","channelName"),
      accVpdId:getParamId2(1900,"snapshot_channel_data","accvpd"),
      hidDliId:getParamId2(1900,"snapshot_channel_data","dailyLightIntegral"),
      irrDliId:getParamId2(1900,"snapshot_channel_data","accumulatedLight"),
      anDliId:getParamId2(1900,"pearl_chan_anx_stat","analogDliAccum"),
      lightModeId:getParamId2(1900,"configuration_channel_data","light_mode"),
      irModeId:getParamId2(1900,"config_channels_configuration","irrigation_mode"),
//       accVpdThreshId:getParamId2(1900,"configuration_channel_data",
//         "vpdacc_threshold"),
//       accAnDliThreshId:getParamId2(1900,"pearl_chan_anx_conf",
//         "analogDliThreshold"),
//       accDliThreshId:getParamId2(1900,"configuration_channel_data",
//         "dliThreshold"),
    }
    for(let ch=0;ch<100;ch++){// "c00" problem
      let eqType=+((dbVals.z[zInd]||[])[ch]||{})[ids.eqTypeId]
      let eqName=((dbVals.z[zInd]||[])[ch]||{})[ids.eqNameId]
      let irrMode=+((dbVals.z[zInd]||[])[ch]||{})[ids.irModeId]
      let lgtMode=+((dbVals.z[zInd]||[])[ch]||{})[ids.lightModeId]

//       let vpdThresh=+(dbVals.z[zInd][ch]||{})[ids.accVpdThreshId]
//       let dliThresh=+(dbVals.z[zInd][ch]||{})[ids.accDliThreshId]
//       let anDliThresh=+(dbVals.z[zInd][ch]||{})[ids.accAnDliThreshId]

      if((eqType==constant.EQ_IRR)&&(irrMode==constant.EQ_MODE_IRR_VPD)){
        let sensor={
          cal:0,
          ch:ch,
          default:[[0,40]],
          id:ids.accVpdId,
          lcIndex:300+ch,// ???
          map:0,
          name:`${eqName}-vpd`,
          name2:eqName,
          sensorIndex:0,
          unitGroup:"Vpdi",
          unit:pressUnit,
//           threshold:vpdThresh,
        }
        let id=`e0c${az(ch,2)}vpd`
        sensorIds[id]=sensor
      }
      if(((eqType==constant.EQ_HID)&&(lgtMode==constant.EQ_MODE_HID_DLI))||
        ((eqType==constant.EQ_IRR)&&(irrMode==constant.EQ_MODE_IRR_DLI))||
        (eqType==constant.EQ_DLI_A)){
        let isHid=(eqType==constant.EQ_HID)
        let isIrr=(eqType==constant.EQ_IRR)
        let sensor={
          cal:0,
          ch:ch,
          default:[[0,50/*e6*/]],
          id:(isIrr)?ids.irrDliId:
            (isHid)?ids.hidDliId:ids.anDliId,
          lcIndex:300+ch,// ???
          map:0,
          name:`${eqName}-dli`,
          name2:eqName,
          sensorIndex:0,
          unitGroup:"dli",
          unit:cumLightUnit,
//           threshold:(isHid)?dliThresh:anDliThresh,
        }
//         cl(sensor.name)
        let id=`e0c${az(ch,2)}dli`
        sensorIds[id]=sensor
      }
//       cl(ch,eqType)

    }
  }

  var fixupGenSens=(zInd,sensorIds)=>{
    makeGenSensorTypeUnits()
    let stId=getParamId2(1900,"pearl_gen_sens_conf","sensorType")
    let svId=getParamId2(1900,"pearl_gen_sens_stat","adjValue")
    let stMult=pInd[1900].pearl_gen_sens_conf[2]
    let svMult=pInd[1900].pearl_gen_sens_stat[2]
    let unitGroups={
      [constant.GENTYPE_NONE]:"None",
      [constant.GENTYPE_GEN]:"None",
      [constant.GENTYPE_SOFT]:"None",
      [constant.GENTYPE_TEMP]:"Temperature",
      [constant.GENTYPE_HUM]:"Humidity",
      [constant.GENTYPE_DHTT]:"Temperature",
      [constant.GENTYPE_DHTH]:"Humidity",
      [constant.GENTYPE_RAIN]:"Weather",
      [constant.GENTYPE_WNDS]:"Wind",
      [constant.GENTYPE_WNDD]:"Wind Direction",
      [constant.GENTYPE_VOLT]:"Volume",
      [constant.GENTYPE_LGHT]:"Light",
      [constant.GENTYPE_ATMP]:"Pressure",
      [constant.GENTYPE_MOIS]:"Saturation",
      [constant.GENTYPE_PRES]:"Pressure",
      [constant.GENTYPE_DINP]:"On/Off",
      [constant.GENTYPE_DSOX]:"DO",
      [constant.GENTYPE_FLOW]:"Flow",
      [constant.GENTYPE_DIST]:"Volume",
      [constant.GENTYPE_PH]:"pH",
      [constant.GENTYPE_EC]:"EC",
    }
    Object.keys(sensorIds).forEach(s=>{
      if(s.substring(2,4)=="gn"){
        let genSensId=+s.substring(4)
        let pid=stId+genSensId*stMult
        let sensorType=+(((dbVals.z[zInd]||{})[240]||{})[pid]||0)
//         cl(s,pid,sensorType)
        if(sensorType){
          pid=svId+genSensId*svMult
          let sensorVal=+(((dbVals.z[zInd]||{})[240]||{})[pid]||0)
          let sensor=sensorIds[s]
          sensor.sensorType=sensorType
          sensor.unit=genSensorTypeUnits[sensorType]
          sensor.default=(sensorType==constant.GENTYPE_DSOX)?[[0,14]]:
            [getRangeFromValue(sensorVal)]
          if(unitGroups[sensorType]){
            sensor.unitGroup=unitGroups[sensorType]}
        }
      }
    })
  }

  var fixupDli=(zInd,sensorIds)=>{
//     cl(sensorIds.e0dli)
    let chTypeId=getParamId("channels_configuration","channelType")
    let ltModeId=getParamId("config_channels_configuration","light_mode")
    let irModeId=getParamId("config_channels_configuration","irrigation_mode")
//     cl(zInd,chTypeId,ltModeId,irModeId)
//     cl(chTypeId)
//     cl(constant.EQ_DLI_A)
    for(let i=0;i<128;i++){
      let chType
      if ((dbVals.z[zInd]||[])[i]) {
        chType = dbVals.z[zInd][i][chTypeId]
      }
//       cl(chType)
      if(chType==constant.EQ_DLI_A){
//         cl("got analog")
        sensorIds.e0dli.ch=i
        sensorIds.e0dli.id=getParamId("pearl_chan_anx_stat","analogDliAccum")
//         cl(sensorIds.e0dli)
        return
      }
      if(chType==constant.EQ_HID){
//         cl("do hid")
        let mode=+dbVals.z[zInd][i][ltModeId]
//         cl(ltModeId,mode)
        if(mode==constant.HID_DLI_MODE){
//           cl(ltModeId)
//           cl(mode)
//           cl("got digital")
          sensorIds.e0dli.ch=i
          sensorIds.e0dli.id=getParamId("snapshot_chan_Snapshot","dailyLightIntegral")
//           cl(sensorIds.e0dli)
          return
        }
      }
//       if(chType==constant.EQ_IRR && dbVals.z[zInd] && dbVals.z[zInd][i] && dbVals.z[zInd][i][irModeId]){
//         let mode=+dbVals.z[zInd][i][irModeId]
// //         cl(irModeId,mode)
//         if(mode==constant.IRR_DLI_MODE){
// //           cl(ltModeId)
// //           cl(mode)
// //           cl("got digital")
//           sensorIds.e0dli.ch=i
//           sensorIds.e0dli.id=getParamId("snapshot_chan_Snapshot","accumulatedLight")
// //           cl(sensorIds.e0dli)
//           return
//         }
//       }
//       if([constant.EQ_DLI_A,constant.EQ_HID].includes(+chType)){
//         if(chType==)
//         cl("got it")
//       }
    }
  }

  var genericTypes=[
    {v:0,t:"None"},
    {v:1,t:"Generic"},
    {v:2,t:"Software"},
    {v:3,t:"Temp",u:"\u00B0"},
    {v:4,t:"Hum",u:"% RH"},
    {v:5,t:"DHT Temp",u:"\u00B0"},
    {v:6,t:"DHT Hum",u:"% RH"},
    {v:7,t:"Rain"},
    {v:8,t:"Wind Speed",u:"Mph"},
    {v:9,t:"Wind Dir"},
    {v:10,t:"Voltage",u:"V"},
    {v:11,t:"Light",u:"uMol"},
    {v:12,t:"BHeat",u:"\u00B0"},
    {v:13,t:"Moisture",u:"%"},
    {v:14,t:"Diff Press",u:"Kpa"},
    {v:15,t:"Digital Inp"},
    {v:16,t:"Dissolved Oxygen",u:"mg/Ltr"},
    {v:17,t:"Flow Rate",u:"Gpm"},
    {v:18,t:"Distance",u:"gal"},
    {v:19,t:"pH"},
    {v:20,t:"EC",u:"uS"},
    {v:21,t:"Gen Temp",u:"\u00B0"},
  ]

  var initSensorIds=(zInd,force/*,zone,gwType*/)=>{
    // cl(sensorIds)
    if(sensorIds&&!force){return}
//     console.trace()
//     cl(zInd)
//     console.trace()
//     cl("init sensor")
//     cl(zInd)
//     console.trace()
//     if(sensorIds){return}
    sensorIds={
      zoS:{ch: 255, id: 0, name:"Zone Setpoint", name2:"Setpoint", unit: nulUnit, unitGroup:"Setpoint", default: [[0, 8]]},
      inT:{
        ch: 240,
        id: getParamId("snapshots","inTemperature"),
        map: getParamId("configuration_unit_settings","Inside Temperature Mapping"), 
        cal: getParamId("configuration_unit_settings","Inside Temperature Calibration"),
        lcIndex:0,// this is the controller's index of the sensor'
        sensorIndex:0,// pretty sure this is not used
        name:"Inside Temperature",
        name2:"In Temp.",
        unit: tempUnit,
        unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      cnT:{
        ch: 240,
        id: getParamId("snapshots","inTemperature"),
        map: getParamId("configuration_unit_settings","Inside Temperature Mapping"),
        cal: getParamId("configuration_unit_settings","Inside Temperature Calibration"),
        lcIndex:0,// this is the controller's index of the sensor'
        sensorIndex:0,// pretty sure this is not used
        name:"Canopy Temperature",
        name2:"Can Temp.",
        unit: tempUnit,
        unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      inH:{ch: 240, id: getParamId("snapshots","inHumidity"),
        map: getParamId("configuration_unit_settings","Relative Humidity Mapping"), 
        cal: getParamId("configuration_unit_settings","Relative Humidity Calibration"), 
        lcIndex:2,
        sensorIndex:1,
        name:"Inside Humidity", name2:"In Hum.",  unit: pctUnit, unitGroup:"Humidity", default: [[20, 100]]},
      inL:{ch: 240, id: getParamId("snapshots","inLight"), 
        map: getParamId("configuration_unit_settings","Inside Light Mapping"), 
        cal: getParamId("configuration_unit_settings","Inside Light Calibration"), 
        lcIndex:21,
        sensorIndex:2,
        name:"Inside Light", name2:"Light",  unit: lightUnit, unitGroup:"Light", default: [[0, 1200], [0, 144], [0, 2400]]},
      dli:{ch: 240, id: getParamId("snapshots","accumDLI"),type:"dli",
        map: null,//getParamId("configuration_unit_settings","Inside Light Mapping"),
        cal: null,//getParamId("configuration_unit_settings","Inside Light Calibration"),
        lcIndex:205,// I really don't know what this means'
        sensorIndex:186,
        name:"Daily Light Integral", name2:"DLI",  unit: cumLightUnit, unitGroup:"DLI",
        default: [[0,20],[0,2],[0,40]]},//[0, 1200], [0, 144], [0, 2400]
      inC:{ch: 240, id: getParamId("snapshots","co2"),
        map: getParamId("configuration_unit_settings","CO2 Mapping"), 
        cal: getParamId("configuration_unit_settings","CO2 Calibration"), 
        lcIndex:3,
        sensorIndex:3,
        name:"Inside CO2", name2:"CO2",  unit: co2Unit, unitGroup:"CO2", default: [[0, 10000]]},
      ouT:{ch: 240, id: getParamId("snapshots","outTemperature"), 
        map: getParamId("configuration_unit_settings","Outside Temperature Mapping"), 
        cal: getParamId("configuration_unit_settings","Outside Temperature Calibration"), 
        lcIndex:1,
        sensorIndex:4,
        name:"Outside Temperature", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      ouH:{ch: 240, id: getParamId("snapshots","outHumidity"), 
        map: getParamId("configuration_unit_settings","Outside Humidity Mapping"), 
        cal: getParamId("configuration_unit_settings","Outside Humidity Calibration"), 
        lcIndex:44,// this is the controller's index of the sensor'
        sensorIndex:5,
        name:"Outside Humidity", name2:"",  unit: pctUnit, unitGroup:"Humidity", default: [[20, 100]]},
      ouL:{ch: 240, id: getParamId("snapshots","outLight"), 
        map: getParamId("configuration_unit_settings","Outside Light Mapping"), 
        cal: getParamId("configuration_unit_settings","Outside Light Calibration"), 
        lcIndex:4,
        sensorIndex:6,
        name:"Outside Light", name2:"",  unit: lightUnit, unitGroup:"Light", default: [[0, 1200], [0, 144], [0, 2400]]},
      bpT:{ch: 240, id: getParamId("snapshots","outTemperatureSecondary"), 
        map: getParamId("configuration_unit_settings","Outside Temperature 2 Mapping"), 
        cal: getParamId("configuration_unit_settings","Outside Temperature 2 Calibration"), 
        lcIndex:48,
        sensorIndex:7,
        name:"Black Plate Temp", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 100], [-10, 40]]},
      oWs:{ch: 240, id: getParamId("snapshots","windSpeed"), 
        map: getParamId("configuration_unit_settings","Wind Speed Mapping"), 
        cal: getParamId("configuration_unit_settings","Wind Speed Calibration"), 
        lcIndex:5,
        sensorIndex:8,
        name:"Wind Speed", name2:"",  unit: windUnit, default: [[0, 30], [0, 20]]},
      oWd:{ch: 240, id: getParamId("snapshots","windDirection"), 
        map: getParamId("configuration_unit_settings","Wind Direction Mapping"), 
        cal: getParamId("configuration_unit_settings","Wind Direction Calibration"), 
        lcIndex:12,
        sensorIndex:9,
        name:"Wind Direction", name2:"",  unit: nulUnit, default: [[0, 16]]},
      dPr:{ch: 240, id: getParamId("snapshots","differentialPressure"), 
        map: getParamId("configuration_unit_settings","Differential Pressure Mapping"), 
        cal: getParamId("configuration_unit_settings","Differential Pressure Calibration"), 
        lcIndex:20,
        sensorIndex:10,
        name:"Differential Pressure", name2:"", name2:"",  unit: pressUnit, unitGroup:"Pressure", default: [[0, 2000], [0, 300], [0, 2]]},
      bPr:{ch: 240, id: getParamId("snapshots","barometricPressure"), 
        map: getParamId("configuration_unit_settings","Barometric Pressure Mapping"), 
        cal: getParamId("configuration_unit_settings","Barometric Pressure Calibration"), 
        lcIndex:49,
        sensorIndex:11,
        name:"Barometric Pressure", name2:"",  unit: pressUnit, unitGroup:"Pressure", default: [[0, 2000], [0, 300], [0, 2]]},
      ran:{ch: 240, id: getParamId("snapshots","rain"), 
        map: getParamId("configuration_unit_settings","Rain Mapping"), 
        cal: getParamId("configuration_unit_settings","Rain Calibration"), 
        lcIndex:18,
        sensorIndex:12,
        name:"Rain", name2:"",  unit: nulUnit,  unitGroup:"Weather ON OFF", default: [[0, 1]]},
      sno:{ch: 240, id: getParamId("snapshots","snow"), 
        map: getParamId("configuration_unit_settings","Snow Mapping"), 
        cal: getParamId("configuration_unit_settings","Snow Calibration"), 
        lcIndex:47,
        sensorIndex:13,
        name:"Snow", name2:"",  unit: nulUnit, unitGroup:"Weather ON OFF", default: [[0, 1]]},
      vpd:{ch: 240, id: getParamId("snapshots","vpd"), 
        sensorIndex:14,
        name:"VPD", name2:"VPD",  unit: pressUnit, default: [[0, 4]]},
      at0:{ch: 240, id: getParamId("snapshots","analogTemperature1"), 
        map: getParamId("configuration_unit_settings","Analog Temperature 1 Mapping"), 
        cal: getParamId("configuration_unit_settings","Analog Temperature 1 Calibration"), 
        lcIndex:6,
        sensorIndex:15,
        name:"Analog Temp 1", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at1:{ch: 240, id: getParamId("snapshots","analogTemperature2"), 
        map: getParamId("configuration_unit_settings","Analog Temperature 2 Mapping"), 
        cal: getParamId("configuration_unit_settings","Analog Temperature 2 Calibration"), 
        lcIndex:7,
        sensorIndex:16,
        name:"Analog Temp 2", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at2:{ch: 240, id: getParamId("snapshots","analogTemperature3"), 
        map: getParamId("configuration_unit_settings","Analog Temperature 3 Mapping"), 
        cal: getParamId("configuration_unit_settings","Analog Temperature 3 Calibration"), 
        lcIndex:8,
        sensorIndex:17,
        name:"Analog Temp 3", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at3:{ch: 240, id: getParamId("snapshots","analogTemperature4"), 
        map: getParamId("configuration_unit_settings","Analog Temperature 4 Mapping"), 
        cal: getParamId("configuration_unit_settings","Analog Temperature 4 Calibration"), 
        lcIndex:9,
        sensorIndex:18,
        name:"Analog Temp 4", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at4:{ch: 240, id: getParamId("snapshots","analogTemperature5"), 
        map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"), 
        cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"), 
        lcIndex:10,
        sensorIndex:19,
        name:"Analog Temp 5", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},

      at5:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp6"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:58,
        sensorIndex:31,
        name:"Analog Temp 6", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at6:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp7"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:59,
        sensorIndex:32,
        name:"Analog Temp 7", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at7:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp8"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:60,
        sensorIndex:33,
        name:"Analog Temp 8", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at8:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp9"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:61,
        sensorIndex:34,
        name:"Analog Temp 9", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at9:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp10"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:62,
        sensorIndex:35,
        name:"Analog Temp 10", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at10:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp11"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:63,
        sensorIndex:36,
        name:"Analog Temp 11", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at11:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp12"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:64,
        sensorIndex:37,
        name:"Analog Temp 12", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at12:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp13"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:65,
        sensorIndex:38,
        name:"Analog Temp 13", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at13:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp14"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:66,
        sensorIndex:39,
        name:"Analog Temp 14", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at14:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp15"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:67,
        sensorIndex:40,
        name:"Analog Temp 15", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at15:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp16"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:68,
        sensorIndex:41,
        name:"Analog Temp 16", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at16:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp17"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:69,
        sensorIndex:42,
        name:"Analog Temp 17", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at17:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp18"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:70,
        sensorIndex:43,
        name:"Analog Temp 18", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at18:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp19"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:71,
        sensorIndex:44,
        name:"Analog Temp 19", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at19:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp20"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:72,
        sensorIndex:45,
        name:"Analog Temp 20", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at20:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp21"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:73,
        sensorIndex:46,
        name:"Analog Temp 21", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at21:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp22"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:74,
        sensorIndex:47,
        name:"Analog Temp 22", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at22:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp23"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:75,
        sensorIndex:48,
        name:"Analog Temp 23", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},
      at23:{ch: 240, id: getParamId2(1900,"pearl_snaps","exTemp24"),
//         map: getParamId("configuration_unit_settings","Analog Temperature 5 Mapping"),
//         cal: getParamId("configuration_unit_settings","Analog Temperature 5 Calibration"),
        lcIndex:76,
        sensorIndex:49,
        name:"Analog Temp 24", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 110], [-10, 40]]},


      vo0:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage1"),
        lcIndex:50,
        sensorIndex:50,
        name:"Voltage 1", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      vo1:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage2"),
        lcIndex:51,
        sensorIndex:51,
        name:"Voltage 2", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      vo2:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage3"),
        lcIndex:52,
        sensorIndex:52,
        name:"Voltage 3", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      vo3:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage4"),
        lcIndex:53,
        sensorIndex:53,
        name:"Voltage 4", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      vo4:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage5"),
        lcIndex:54,
        sensorIndex:54,
        name:"Voltage 5", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      vo5:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage6"),
        lcIndex:55,
        sensorIndex:55,
        name:"Voltage 6", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      vo6:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage7"),
        lcIndex:56,
        sensorIndex:56,
        name:"Voltage 7", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      vo7:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage8"),
        lcIndex:57,
        sensorIndex:57,
        name:"Voltage 8", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},

      // dv0:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage1"),
      //   lcIndex:50,
      //   sensorIndex:50,
      //   name:"Digital 1", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      // dv1:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage2"),
      //   lcIndex:51,
      //   sensorIndex:51,
      //   name:"Digital 2", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      // dv2:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage3"),
      //   lcIndex:52,
      //   sensorIndex:52,
      //   name:"Digital 3", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      // dv3:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage4"),
      //   lcIndex:53,
      //   sensorIndex:53,
      //   name:"Digital 4", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      // dv4:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage5"),
      //   lcIndex:54,
      //   sensorIndex:54,
      //   name:"Digital 5", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      // dv5:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage6"),
      //   lcIndex:55,
      //   sensorIndex:55,
      //   name:"Digital 6", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      // dv6:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage7"),
      //   lcIndex:56,
      //   sensorIndex:56,
      //   name:"Digital 7", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},
      // dv7:{ch: 240, id: getParamId2(1900,"pearl_snaps","voltage8"),
      //   lcIndex:57,
      //   sensorIndex:57,
      //   name:"Digital 8", name2:"",  unit: voltUnit, unitGroup:"Voltage", default: [[0, 10]]},


      vp0:{ch: 240, id: getParamId("snapshots","ventPosition1"),
        map: getParamId("configuration_unit_settings","Vent Position Sensor 1 Mapping"), 
        cal: getParamId("configuration_unit_settings","Vent Position Sensor 1 Calibration"), 
        lcIndex:32,
        sensorIndex:20,
        name:"Vent Position 1", name2:"",  unit: pctUnit, unitGroup:"Position", default: [[0, 100]]},
      vp1:{ch: 240, id: getParamId("snapshots","ventPosition2"),
        map: getParamId("configuration_unit_settings","Vent Position Sensor 2 Mapping"), 
        cal: getParamId("configuration_unit_settings","Vent Position Sensor 2 Calibration"), 
        lcIndex:33,
        sensorIndex:21,
        name:"Vent Position 2", name2:"",  unit: pctUnit, unitGroup:"Position", default: [[0, 100]]},
      vp2:{ch: 240, id: getParamId("snapshots","ventPosition3"), 
        map: getParamId("configuration_unit_settings","Vent Position Sensor 3 Mapping"), 
        cal: getParamId("configuration_unit_settings","Vent Position Sensor 3 Calibration"), 
        lcIndex:34,
        sensorIndex:22,
        name:"Vent Position 3", name2:"",  unit: pctUnit, unitGroup:"Position", default: [[0, 100]]},
      vp3:{ch: 240, id: getParamId("snapshots","ventPosition4"), 
        map: getParamId("configuration_unit_settings","Vent Position Sensor 4 Mapping"), 
        cal: getParamId("configuration_unit_settings","Vent Position Sensor 4 Calibration"), 
        lcIndex:35,
        sensorIndex:23,
        name:"Vent Position 4", name2:"",  unit: pctUnit, unitGroup:"Position", default: [[0, 100]]},
      vp4:{ch: 240, id: getParamId("snapshots","ventPosition5"), 
        map: getParamId("configuration_unit_settings","Vent Position Sensor 5 Mapping"), 
        cal: getParamId("configuration_unit_settings","Vent Position Sensor 5 Calibration"), 
        lcIndex:36,
        sensorIndex:24,
        name:"Vent Position 5", name2:"",  unit: pctUnit, unitGroup:"Position", default: [[0, 100]]},
      sm0:{ch: 240, id: getParamId("snapshots","soilMoisture1"), 
        map: getParamId("configuration_unit_settings","Soil Moisture 1 Mapping"), 
        cal: getParamId("configuration_unit_settings","Soil Moisture 1 Calibration"), 
        lcIndex:13,
        sensorIndex:25,
        name:"Soil Moisture 1", name2:"",  unit: pctUnit, unitGroup:"Saturation", default: [[0, 100]]},
      sm1:{ch: 240, id: getParamId("snapshots","soilMoisture2"), 
        map: getParamId("configuration_unit_settings","Soil Moisture 2 Mapping"), 
        cal: getParamId("configuration_unit_settings","Soil Moisture 2 Calibration"), 
        lcIndex:14,
        sensorIndex:26,
        name:"Soil Moisture 2", name2:"",  unit: pctUnit, unitGroup:"Saturation", default: [[0, 100]]},
      sm2:{ch: 240, id: getParamId("snapshots","soilMoisture3"), 
        map: getParamId("configuration_unit_settings","Soil Moisture 3 Mapping"), 
        cal: getParamId("configuration_unit_settings","Soil Moisture 3 Calibration"), 
        lcIndex:15,
        sensorIndex:27,
        name:"Soil Moisture 3", name2:"",  unit: pctUnit, unitGroup:"Saturation", default: [[0, 100]]},
      sm3:{ch: 240, id: getParamId("snapshots","soilMoisture4"), 
        map: getParamId("configuration_unit_settings","Soil Moisture 4 Mapping"), 
        cal: getParamId("configuration_unit_settings","Soil Moisture 4 Calibration"), 
        lcIndex:16,
        sensorIndex:28,
        name:"Soil Moisture 4", name2:"",  unit: pctUnit, unitGroup:"Saturation", default: [[0, 100]]},
      sm4:{ch: 240, id: getParamId("snapshots","soilMoisture5"), 
        map: getParamId("configuration_unit_settings","Soil Moisture 5 Mapping"), 
        cal: getParamId("configuration_unit_settings","Soil Moisture 5 Calibration"), 
        lcIndex:17,
        sensorIndex:29,
        name:"Soil Moisture 5", name2:"",  unit: pctUnit, unitGroup:"Saturation", default: [[0, 100]]},
      
      gn0:{ch: 240, id: getParamId2(1900,"pearl_gen_sens_stat","adjValue"),
        map:getParamId2(1900,"pearl_gen_sens_conf","mapping"),
        cal:getParamId2(1900,"pearl_gen_sens_conf","calibrate"),
        lcIndex:77,
        sensorIndex:58,
        name:"Generic Sensor 1", name2:"",  unit: pctUnit, unitGroup:"Saturation", default: [[0, 100]]},

      fbT:{ch: 240, id: getParamId("snapshots","backupTemperature"),
        map: getParamId("configuration_unit_settings","Fallback Sensor Input Mapping"), 
        cal: getParamId("configuration_unit_settings","Fallback Temperature Calibration"), 
        lcIndex:11,
        sensorIndex:30,
        name:"Fallback Temperature", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 100], [-10, 40]]},
/* Fallback humidity is Pearl-only, so unlike fbT above it uses the live pearl
tables throughout rather than the 1800 controller_configuration_settings ones.
map is pearl_sensor_config indexed by INPUTIDX (22), which is what the Input
Mapping page writes; cal is the new pearl_config entry for firmware id 638.
sensorIndex is the config_annex_sensors alarm row, not the controller index -
187 is the first free slot (0-57 fixed sensors, 58-185 generics, 186 dli). It
must match the ind of the fbH entry in ngui-node utils.js sensors, which is
what the alarm evaluator uses to find these settings. */
      fbH:{ch: 240, id: getParamId2(1900,"pearl_snaps","FallbackInHum"),
        map: getParamId2(1900,"pearl_sensor_config","mapping")+
          22*(pInd[1900]?.pearl_sensor_config?.[2]||3),// 22 = INPUTIDX_FBINHUM
        cal: getParamId2(1900,"pearl_config","fbHumCalibration"),
        lcIndex:22,
        sensorIndex:187,
        name:"Fallback Humidity", name2:"",  unit: pctUnit, unitGroup:"Humidity", default: [[0, 100]]},
//       cnT:{ch: 240, id: getParamId("snapshots","backupTemperature"),
//         map: getParamId("configuration_unit_settings","Fallback Sensor Input Mapping"),
//         cal: getParamId("configuration_unit_settings","Fallback Temperature Calibration"),
//         lcIndex:11,
//         sensorIndex:30,
//         name:"Canopy Temperature", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 100], [-10, 40]]},

      // TODO get actual stage named got temp
      stT:{ch: 240, id: getParamId("snapshots","temperatureStage"), name:"Temperature Stage", name2:"Temp. Stage",  unit: nulUnit, unitGroup:"Stage", default: [[0, 12]]},
      stH:{ch: 240, id: getParamId("snapshots","humidityStage"), name:"Humidity Stage", name2:"Hum. Stage",  unit: nulUnit, unitGroup:"Stage", default: [[0, 3]]},
      spH:{ch: 240, id: getParamId("snapshots","heatSetpoint"), name:"Heat Setpoint", name2:"", unit: tempUnit, unitGroup:"Temperature", default: [[20, 100], [-10, 40]]},
      spC:{ch: 240, id: getParamId("snapshots","coolSetpoint"), name:"Cool Setpoint", name2:"", unit: tempUnit, unitGroup:"Temperature", default: [[20, 100], [-10, 40]]},
      spU:{ch: 240, id: getParamId("snapshots","humidifySetpoint"), name:"Humidify Setpoint", name2:"",  unit: pctUnit, unitGroup:"Humidity", default: [[0, 100]]},
      spD:{ch: 240, id: getParamId("snapshots","dehumidifySetpoint"), name:"De-Humidify Setpoint", name2:"",  unit: pctUnit, unitGroup:"Humidity", default: [[0, 100]]},
      alL:{ch: 240, id: getParamId("snapshots","lowAlarm"), name:"Low Alarm", name2:"",  unit: nulUnit, unitGroup:"ON OFF", default: [[0, 1]]},
      alH:{ch: 240, id: getParamId("snapshots","highAlarm"), name:"High Alarm", name2:"",  unit: nulUnit, unitGroup:"ON OFF", default: [[0, 1]]},
      chP:{ch: 240, id: getParamId("snapshot_channels","position"), name:"Channel Position", name2:"",  unit: nulUnit, unitGroup:"ON OFF", default: [[0, 1]]},
      chO:{ch: 240, id: getParamId("snapshot_channels","channelOverride"), name:"Channel Override", name2:"",  unit: nulUnit, unitGroup:"OVR", default: [[0, 24]]},
      ec:{ch: 192, id: getParamId("snapshot_ecphs","ec1"), name:"EC", name2:"EC",  unit: nuteUnit, default: [[0, 3000], [0, 1500]]},
      ph:{ch: 192, id: getParamId("snapshot_ecphs","ph1"), name:"pH", name2:"pH",  unit: nulUnit, unitGroup:"Stage", default: [[0, 14]]},
      tp:{ch: 192, id: getParamId("snapshot_ecphs","temperature1"), name:"ECpH Temperature", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 100], [-10, 40]]},
      taH:{ch: 255, id: getParamId("configuration_zone_settings","High Alarm Temperature Above Cool Setpoint Threshold"), 
          name:"High Temp Alarm", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 100], [-10, 40]]},
      taL:{ch: 255, id: getParamId("configuration_zone_settings","Low Alarm Temperature Below Heat Setpoint Threshold"), 
          name:"Low Temp Alarm", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[20, 100], [-10, 40]]},
      vpL:{ch: 240, id: getParamId("configuration_unit_settings","VPD Min"), name:"vpMin", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[0, 4]]},
      vpH:{ch: 240, id: getParamId("configuration_unit_settings","VPD Max"), name:"vpMax", name2:"",  unit: tempUnit, unitGroup:"Temperature", default: [[0, 4]]},
      eL:{ch: 192, id: getParamId("configuration_ecph","lowECThreshold"), name:"Low EC Alarm", name2:"",  unit: nuteUnit, unitGroup:"ON OFF", default: [[0, 1]]},
      eH:{ch: 192, id: getParamId("configuration_ecph","highECThreshold"), name:"High EC Alarm", name2:"",  unit: nuteUnit, unitGroup:"ON OFF", default: [[0, 1]]},
      pL:{ch: 192, id: getParamId("configuration_ecph","lowPHThreshold"), name:"Low pH Alarm", name2:"",  unit: nulUnit, unitGroup:"ON OFF", default: [[0, 1]]},
      pH:{ch: 192, id: getParamId("configuration_ecph","highPHThreshold"), name:"High pH Alarm", name2:"",  unit: nulUnit, unitGroup:"ON OFF", default: [[0, 1]]},
      taN:{ch: 192, id: getParamId("configuration_ecph","name"), name:"Tank Name", name2:"",  unit: nulUnit},
    }
    add800SensorIds(sensorIds)
    initAddedSensors(zInd)
//     initMBRegisters(zInd,zone)
    fixSensorIds(zInd)
    addGSensors(sensorIds)
    addAuxSensors(sensorIds,zInd)
//     cl("fix up dli")
//     cl(sensorIds["e0c04dli"]?.name)
    fixupDli(zInd,sensorIds)
    fixupGenSens(zInd,sensorIds)
//     cl(sensorIds["e0c04dli"]?.name)
    addVpdDli(zInd,sensorIds)
//     cl(sensorIds["e0gn2"])
//     console.trace()
//     cl(sensorIds["e0c04dli"]?.name)
  }

  var add800SensorIds=(sensorIds)=>{
    sensorIds["inT800"]=Object.assign({},sensorIds.inT)
    let s=sensorIds.inT800
    s.name="inTemp(800)"
    s.id=getParamId800("igR","inTemperature")
    sensorIds["inH800"]=Object.assign({},sensorIds.inH)
    s=sensorIds.inH800
    s.name="inHum(800)"
    s.id=getParamId800("igR","inHumidity")
//     cl(sensorIds)
  }

  var xBoardShorts={
    "0":"None",					//  0: MB_SLAVE_TYPE_NONE
    "1":"24DO",	//  1: MB_SLAVE_TYPE_24OUT
    "2":"8DO",		//  2: MB_SLAVE_TYPE_8OUT
    "3":"4DO",		//  3: MB_SLAVE_TYPE_4OUT
    "4":"2DO",		//  4: MB_SLAVE_TYPE_2OUT
    "5":"ECpH",				//  5: MB_SLAVE_TYPE_EC_PH
    "6":"2AO",		//  6: MB_SLAVE_TYPE_ANALOG_2OUT
    "7":"1AO",		//  7: MB_SLAVE_TYPE_ANALOG_1OUT
    "8":"3AO",		//  8: MB_SLAVE_TYPE_ANALOG_3OUT
    "9":"5AO",		//  9: MB_SLAVE_TYPE_ANALOG_5OUT
    "10":"Sens",				// 10: MB_SLAVE_TYPE_SENSOR_MODULE
    "11":"16AI",				// 11: MB_SLAVE_TYPE_ANALOG_16INPUT
    "12":"A8D8",		// 12:  MB_SLAVE_TYPE_CONTROLLER
    "13":"8+TH",        // 13:  MB_SLAVE_TYPE_ANALOG_10IN_DHT
    "14":"4A4D",		// 14:  MB_SLAVE_TYPE_4A_4D_OUTPUT
    "15":"DTH",		// 15:  MB_SLAVE_TYPE_DTH
    "16":"5+TH",		// 16:  MB_SLAVE_TYPE_ANALOG_7IN_DHT
    "17":"DTH5",		// 16:  MB_SLAVE_TYPE_DTH_5
    "18":"4OTH",		// 16:  MB_SLAVE_TYPE_DTH_5
    "19":"8OTH",		// 16:  MB_SLAVE_TYPE_8OUT_DTH
    "20":"4AOTH",		// 20:  MB_SLAVE_TYPE_ANALOG_4OUT_DTH
    "21":"2O DTH",		// 17:  MB_SLAVE_TYPE_CONTROLLER
    "22":"5In Irr",		// 17:  MB_SLAVE_TYPE_CONTROLLER
    "23":"JPro",		// 17:  MB_SLAVE_TYPE_CONTROLLER
    "101":"PANA",		// 17:  MB_SLAVE_TYPE_PEARL_ANALOG
    "102":"PIRR",		// 17:  MB_SLAVE_TYPE_PEARL_ANALOG
  }

  var gmbAddXBoardShorts=async(gatewayId)=>{
//     cl(gatewayId)
// add the gmb boards for this gateway
    let gw=globs.gatewaysInfo.info.filter(
      g=>{return g.gatewayId==gatewayId})[0]||{}
//     cl(gw)
    if(!gw.gmbDeviceTypes){return}
    let query={type:"gmbDevTypes"}
    let devTypes=((await wsTrans("usa", {cmd: "cRest", uri: "/s/gmbConfig",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query}))?.data||[])[0]?.vals
//     cl(devTypes)
    gw.gmbDeviceTypes.forEach((t,i)=>{
//       cl(t)
//       cl(devTypes[t])
      xBoardShorts[i+constant.MB_GMB_0]=devTypes[t].name
    })
//     cl(xBoardShorts)
  }

   var allSense=[
"InTemp ", "OutTemp  ", "Hum ", "Co2 ", "Outlite ", "Winspd ", "Bheat1 ", "Bheat2 ", "Bheat3 ", "Bheat4 ", "Bheat5 ", "FbinTemp  ", "Windir ", "Soil1 ", "Soil2 ", "Soil3 ", "Soil4 ", "Soil5 ", "Rain ", "Irr Trig ", "Diffp ", "Inlight ", "X22", "X23", "X24", "X25", "X26", "X27", "X28", "X29", "X30", "X31", "Ventpos1 ", "Ventpos2 ", "Ventpos3 ", "Ventpos4 ", "Ventpos5 ", "X37", "X38", "X39", "X40", "X41", "Generic 1 ", "Generic 2 ", "Outhum ", "Local InTemp  ", "Local Inhum ", "Snow ", "OutTemp 2 ", "Baro ", "Voltage1 ", "Voltage2 ", "Voltage3 ", "Voltage4 ", "Voltage5 ", "Voltage6 ", "Voltage7 ", "Voltage8 ", "Temp 1", "Temp 2", "Temp 3", "Temp 4", "Temp 5", "Temp 6", "Temp 7", "Temp 8", "Temp 9", "Temp 10", "Temp 11", "Temp 12", "Temp 13", "Temp 14", "Temp 15", "Temp 16", "Temp 17", "Temp 18", "Temp 19", "Generic 1", "Generic 2", "Generic 3", "Generic 4", "Generic 5", "Generic 6", "Generic 7", "Generic 8", "Generic 9", "Generic 10", "Generic 11", "Generic 12", "Generic 13", "Generic 14", "Generic 15", "Generic 16", "Generic 17", "Generic 18", "Generic 19", "Generic 20", "Generic 21", "Generic 22", "Generic 23", "Generic 24", "Generic 25", "Generic 26", "Generic 27", "Generic 28", "Generic 29", "Generic 30", "Generic 31", "Generic 32", "Generic 33", "Generic 34", "Generic 35", "Generic 36", "Generic 37", "Generic 38", "Generic 39", "Generic 40", "Generic 41", "Generic 42", "Generic 43", "Generic 44", "Generic 45", "Generic 46", "Generic 47", "Generic 48", "Generic 49", "Generic 50", "Generic 51", "Generic 52", "Generic 53", "Generic 54", "Generic 55", "Generic 56", "Generic 57", "Generic 58", "Generic 59", "Generic 60", "Generic 61", "Generic 62", "Generic 63", "Generic 64", "Generic 65", "Generic 66", "Generic 67", "Generic 68", "Generic 69", "Generic 70", "Generic 71", "Generic 72", "Generic 73", "Generic 74", "Generic 75", "Generic 76", "Generic 77", "Generic 78", "Generic 79", "Generic 80", "Generic 81", "Generic 82", "Generic 83", "Generic 84", "Generic 85", "Generic 86", "Generic 87", "Generic 88", "Generic 89", "Generic 90", "Generic 91", "Generic 92", "Generic 93", "Generic 94", "Generic 95", "Generic 96", "Generic 97", "Generic 98", "Generic 99", "Generic 100", "Generic 101", "Generic 102", "Generic 103", "Generic 104", "Generic 105", "Generic 106", "Generic 107", "Generic 108", "Generic 109", "Generic 110", "Generic 111", "Generic 112", "Generic 113", "Generic 114", "Generic 115", "Generic 116", "Generic 117", "Generic 118", "Generic 119", "Generic 120", "Generic 121", "Generic 122", "Generic 123", "Generic 124", "Generic 125", "Generic 126", "Generic 127", "Generic 128"]
//  {t:"InTemp ",v:0}, {t:"OutTemp  ",v:1}, {t:"Hum ",v:2}, {t:"Co2 ",v:3}, {t:"Outlite ",v:4},
//  {t:"Winspd ",v:5}, {t:"Bheat1 ",v:6}, {t:"Bheat2 ",v:7}, {t:"Bheat3 ",v:8}, {t:"Bheat4 ",v:9},
//  {t:"Bheat5 ",v:10}, {t:"FbinTemp  ",v:11}, {t:"Windir ",v:12}, {t:"Soil1 ",v:13}, {t:"Soil2 ",v:14},
//  {t:"Soil3 ",v:15}, {t:"Soil4 ",v:16}, {t:"Soil5 ",v:17}, {t:"Rain ",v:18}, {t:"Irr Trig ",v:19},
//  {t:"Diffp ",v:20}, {t:"Inlight ",v:21}, {t:"X22",v:22}, {t:"X23",v:23}, {t:"X24",v:24},
//  {t:"X25",v:25}, {t:"X26",v:26}, {t:"X27",v:27}, {t:"X28",v:28}, {t:"X29",v:29}, {t:"X30",v:30},
//  {t:"X31",v:31}, {t:"Ventpos1 ",v:32}, {t:"Ventpos2 ",v:33}, {t:"Ventpos3 ",v:34},
//  {t:"Ventpos4 ",v:35}, {t:"Ventpos5 ",v:36}, {t:"X37",v:37}, {t:"X38",v:38}, {t:"X39",v:39},
//  {t:"X40",v:40}, {t:"X41",v:41}, {t:"Generic 1 ",v:42}, {t:"Generic 2 ",v:43}, {t:"Outhum ",v:44},
//  {t:"Local InTemp  ",v:45}, {t:"Local Inhum ",v:46}, {t:"Snow ",v:47}, {t:"OutTemp 2 ",v:48},
//  {t:"Baro ",v:49}, {t:"Voltage1 ",v:50}, {t:"Voltage2 ",v:51}, {t:"Voltage3 ",v:52},
//  {t:"Voltage4 ",v:53}, {t:"Voltage5 ",v:54}, {t:"Voltage6 ",v:55}, {t:"Voltage7 ",v:56},
//  {t:"Voltage8 ",v:57}, {t:"Temp 1",v:58}, {t:"Temp 2",v:59}, {t:"Temp 3",v:60}, {t:"Temp 4",v:61},
//  {t:"Temp 5",v:62}, {t:"Temp 6",v:63}, {t:"Temp 7",v:64}, {t:"Temp 8",v:65}, {t:"Temp 9",v:66},
//  {t:"Temp 10",v:67}, {t:"Temp 11",v:68}, {t:"Temp 12",v:69}, {t:"Temp 13",v:70}, {t:"Temp 14",v:71},
//  {t:"Temp 15",v:72}, {t:"Temp 16",v:73}, {t:"Temp 17",v:74}, {t:"Temp 18",v:75}, {t:"Temp 19",v:76},
//  {t:"Generic 1",v:77}, {t:"Generic 2",v:78}, {t:"Generic 3",v:79}, {t:"Generic 4",v:80},
//  {t:"Generic 5",v:81}, {t:"Generic 6",v:82}, {t:"Generic 7",v:83}, {t:"Generic 8",v:84},
//  {t:"Generic 9",v:85}, {t:"Generic 10",v:86}, {t:"Generic 11",v:87}, {t:"Generic 12",v:88},
//  {t:"Generic 13",v:89}, {t:"Generic 14",v:90}, {t:"Generic 15",v:91}, {t:"Generic 16",v:92},
//  {t:"Generic 17",v:93}, {t:"Generic 18",v:94}, {t:"Generic 19",v:95}, {t:"Generic 20",v:96},
//  {t:"Generic 21",v:97}, {t:"Generic 22",v:98}, {t:"Generic 23",v:99}, {t:"Generic 24",v:100},
//  {t:"Generic 25",v:101}, {t:"Generic 26",v:102}, {t:"Generic 27",v:103}, {t:"Generic 28",v:104},
//  {t:"Generic 29",v:105}, {t:"Generic 30",v:106}, {t:"Generic 31",v:107}, {t:"Generic 32",v:108},
//  {t:"Generic 33",v:109}, {t:"Generic 34",v:110}, {t:"Generic 35",v:111}, {t:"Generic 36",v:112},
//  {t:"Generic 37",v:113}, {t:"Generic 38",v:114}, {t:"Generic 39",v:115}, {t:"Generic 40",v:116},
//  {t:"Generic 41",v:117}, {t:"Generic 42",v:118}, {t:"Generic 43",v:119}, {t:"Generic 44",v:120},
//  {t:"Generic 45",v:121}, {t:"Generic 46",v:122}, {t:"Generic 47",v:123}, {t:"Generic 48",v:124},
//  {t:"Generic 49",v:125}, {t:"Generic 50",v:126}, {t:"Generic 51",v:127}, {t:"Generic 52",v:128},
//  {t:"Generic 53",v:129}, {t:"Generic 54",v:130}, {t:"Generic 55",v:131}, {t:"Generic 56",v:132},
//  {t:"Generic 57",v:133}, {t:"Generic 58",v:134}, {t:"Generic 59",v:135}, {t:"Generic 60",v:136},
//  {t:"Generic 61",v:137}, {t:"Generic 62",v:138}, {t:"Generic 63",v:139}, {t:"Generic 64",v:140},
//  {t:"Generic 65",v:141}, {t:"Generic 66",v:142}, {t:"Generic 67",v:143}, {t:"Generic 68",v:144},
//  {t:"Generic 69",v:145}, {t:"Generic 70",v:146}, {t:"Generic 71",v:147}, {t:"Generic 72",v:148},
//  {t:"Generic 73",v:149}, {t:"Generic 74",v:150}, {t:"Generic 75",v:151}, {t:"Generic 76",v:152},
//  {t:"Generic 77",v:153}, {t:"Generic 78",v:154}, {t:"Generic 79",v:155}, {t:"Generic 80",v:156},
//  {t:"Generic 81",v:157}, {t:"Generic 82",v:158}, {t:"Generic 83",v:159}, {t:"Generic 84",v:160},
//  {t:"Generic 85",v:161}, {t:"Generic 86",v:162}, {t:"Generic 87",v:163}, {t:"Generic 88",v:164},
//  {t:"Generic 89",v:165}, {t:"Generic 90",v:166}, {t:"Generic 91",v:167}, {t:"Generic 92",v:168},
//  {t:"Generic 93",v:169}, {t:"Generic 94",v:170}, {t:"Generic 95",v:171}, {t:"Generic 96",v:172},
//  {t:"Generic 97",v:173}, {t:"Generic 98",v:174}, {t:"Generic 99",v:175}, {t:"Generic 100",v:176},
//  {t:"Generic 101",v:177}, {t:"Generic 102",v:178}, {t:"Generic 103",v:179}, {t:"Generic 104",v:180},
//  {t:"Generic 105",v:181}, {t:"Generic 106",v:182}, {t:"Generic 107",v:183}, {t:"Generic 108",v:184},
//  {t:"Generic 109",v:185}, {t:"Generic 110",v:186}, {t:"Generic 111",v:187}, {t:"Generic 112",v:188},
//  {t:"Generic 113",v:189}, {t:"Generic 114",v:190}, {t:"Generic 115",v:191}, {t:"Generic 116",v:192},
//  {t:"Generic 117",v:193}, {t:"Generic 118",v:194}, {t:"Generic 119",v:195}, {t:"Generic 120",v:196},
//  {t:"Generic 121",v:197}, {t:"Generic 122",v:198}, {t:"Generic 123",v:199}, {t:"Generic 124",v:200},
//  {t:"Generic 125",v:201}, {t:"Generic 126",v:202}, {t:"Generic 127",v:203}, {t:"Generic 128",v:204},
//     ]


  
//   initSensorIds()
  
  var setSensorIdNames=/*async*/(zoneId)=>{
//     cl("set sensor ids")
//   cl(sensorIds["e0gn0"].name)
//     console.trace()
    /*await */loadSensorsInfo()
    let {sensorNames,sensorUnits}=(getSensorsZone(zoneId)||{})//.sensorNames
//     cl(sensorNames)
//     cl(sensorUnits)
//   cl(sensorIds["e0gn0"].name)
//     cl(sensorNames)
//     cl(Object.keys(sensorNames).length)
    if(sensorNames){
      Object.keys(sensorIds).forEach(k=>{
        if(sensorNames[k]){
          if(k.substring(0,3)!="e0c"){// if *not* channel-specific
            sensorIds[k].name=sensorNames[k]
            sensorIds[k].custUnit=sensorUnits?.[k]
          }
        } else{
          if(k.substring(0,2)!="e0"){
            sensorIds[k].name=`E${k.substring(1,2)}-${sensorIds[k].name}`
          }
        }
      })
//       cl(sensorIds.e0at0.name)
    }else{
      let zi=getZoneInfo(zoneId)
      if (zi) {
        let zInd=zi?.siteZoneIndex
//         cl(zi)
        initSensorIds(zInd,zi?.zoneId,zi?.gatewayType)
      }
    }
//   cl(sensorIds["e0gn0"].name)
  }

var chanVpdIds=(zInd,ch)=>{
//   cl("vpd")
  let accVpdThreshId=getParamId2(1900,"configuration_channel_data",
    "vpdacc_threshold")


  let vpdThresh=+(dbVals.z[zInd][ch]||{})[accVpdThreshId]
//   let accVpdId=getParamId2(1900,"snapshot_channel_data",
//     "accvpd")
//   let eqNameId=getParamId2(1900,"configuration_channels",
//     "channelName")
//   let ch=dbVals.z[zone][chan]
//   let thresh=ch[accVpdThreshId]
//   let val=ch[accVpdId]
// //   cl(val)
//   let name=`${ch[eqNameId]}-vpdi`
  return {ch: ch, id: getParamId("snapshot_channel_data","accvpd"),
    name:`Channel ${ch+1} Vpdi`, unit: nulUnit,threshold:vpdThresh}
}
  
var chanDliIds=(zInd,ch)=>{
//   cl("dli"+zInd)
  let eqTypeId=getParamId2(1900,"configuration_channels",
    "channelType")
//   cl(eqTypeId)
  let eqType=dbVals.z[zInd][ch][eqTypeId]
//   cl(eqType)
  let isHid=eqType==constant.EQ_HID
  let isIrr=eqType==constant.EQ_IRR
  let pid=(isHid)?
    getParamId2(1900,"snapshot_channel_data","dailyLightIntegral"):
    getParamId2(1900,"pearl_chan_anx_stat","analogDliAccum")
  if(isIrr){
    pid=getParamId2(1900,"snapshot_channel_data","accumulatedLight")
  }

  let accAnDliThreshId=getParamId2(1900,"pearl_chan_anx_conf",
    "analogDliThreshold")
  let accDliThreshId=getParamId2(1900,"configuration_channel_data",
    "dliThreshold")
  let accIrrDliThreshId=getParamId2(1900,"configuration_channel_data",
    "setting_2_threshold_light")

  let dliThresh=+(dbVals.z[zInd][ch]||{})[accDliThreshId]
  let anDliThresh=+(dbVals.z[zInd][ch]||{})[accAnDliThreshId]
  let irrDliThresh=getIrrAccLiteThresh(dbVals.z[zInd][ch],zInd)
//   cl(irrDliThresh)
//   let irrDliThresh=+(dbVals.z[zInd][ch]||{})[accIrrDliThreshId]
  let threshold=(isIrr)?irrDliThresh:
    (isHid)?dliThresh:anDliThresh
  cl(threshold)

  return {ch: ch, id: pid,
    name:`Channel ${ch+1} Dli`, unit: nulUnit,threshold:threshold/**1e6*/}
}

var chanPosIds=(ch,zInd,type)=>{
  switch(type){
    case "vpd":
      return chanVpdIds(zInd,ch)
    case "dli":
      return chanDliIds(zInd,ch)
    default:
      return {ch: ch, id: getParamId("snapshot_channels","position"),
        name:`Channel ${ch+1} Position`, unit: nulUnit}
  }
}  
  
  var chanOvrIds=(ch,zInd,type)=>{
    switch(type){
//       case "vpd":
//         return chanVpdIds(zInd,ch)
//       case "dli":
//         return chanDliIds(zInd,ch)
      default:
        return {ch: ch, id: getParamId("snapshot_channels","channelOverride"),
          name:`Channel ${ch+1} Override`, unit: nulUnit}
    }
  }

  var eqOverrides={
  0: "",
  1: "Timed Override",
  2: "Humidify Override",
  3: "Dehumidify 1 Override",
  4: "Dehumidify 2 Override",
  5: "Dehum Low Temp Override",
  6: "Wind Override",
  7: "Rain Override",
  8: "Low Out Temp Override",
  9: "High Out Temp Override",
  10: "Aux Control Override",
  11: "EC/pH Tank Override",
  12: "Fire Override",
  13: "Wind Break Override",
  14: "Open Field Override",
  15: "Shade House Override",
  16: "Humidity Increase Override",
  17: "Crop Protection 1 Override",
  18: "Crop Protection 2 Override",
  19: "Crop Protection 3 Override",
  20: "Structural Protection Override",
  21: "Hail Override",
  22: "Time Override",
  23: "Sched Override",
  24: "Rain Skip Override",
  25: "Water Now Override",
  26: "Walk Valve Override",
}
  
var idToTabInd=(id,zType)=>{
//   cl(tableBases2,zType)
//   cl(tableBases2[zType])
    for (let i = 0 ; i < tableBases2[zType]?.length ; i++){
//       cl(id,tableBases2[zType][i][0])
      if(tableBases2[zType][i][0] > id) return i - 1;
    }
  }
  
var tabIndToName=(base, zType=1800)=>{
    for(let i=0; i<Object.keys(pInd[zType]).length; i++){
      let k=Object.keys(pInd[zType])[i];
      if(pInd[zType][k][0]==base)return k
    }
  }

var tabOffsetToName=(tab,tabName, ofs, zType=1800)=>{
//     cl([tabName,ofs])
//   cl(tab,tabName,ofs)
//   if(ofs==139){
//     cl(Object.keys(pi[zType][tabName]))
//   }
    if([6,7].includes(tab[1])){ofs=(ofs-1)/2}

    if(([0,3,4].includes(tab[1]))&&(tab[2]>1)){ofs=ofs%tab[2]}
//     cl(ofs)
//     cl(ofs,ofs%tab[2])
//     if([4].includes(tab[1])){ofs=}
//     cl(Object.keys(pi[zType][tabName]))
    for(let i=0; i<Object.keys(pi[zType][tabName]).length; i++){
      let k=Object.keys(pi[zType][tabName])[i]
//       cl(k,ofs)
//       cl(pi[zType],tabName,k)
//       cl(pi[zType][tabName][k],ofs)
      if([6,7].includes(tab[1])){
        if(pi[zType][tabName][k]==ofs) return k
      }else{
        if(pi[zType][tabName][k]==ofs%((tab[2])?tab[2]:1e6)) return k
      }
        
    }
  }
  
var getDatapointName=(pid,zType)=>{
//   cl(pid,zType)
    if(!pid) return ""
    // cl(globs.siteZoneTypes)
    // let zType=globs.siteZoneTypes[z]
    // if(zType!=1800){return "Unknown"}
    // cl(zType)
    let ind = idToTabInd(pid,zType)
//     cl(ind)
    if (ind==null) return ""
    let tab=(tableBases2[zType][ind])
    if (!tab) return ""
    let base=tab[0]
    let tabName=tabIndToName(base, zType)
//     if(pid==4855){
//       cl(tab, tabName, pid-base, zType)
//     }
    let ofsName=tabOffsetToName(tab, tabName, pid-base, zType)
//     if(pid==4855){
// //       cl(tableBases2)
//       cl(tabName,pid-base,zType,ofsName,tab)
//     }
//     cl(ofsName)
    let type=tab[1]
    let abv = (tabName.indexOf("snap")>=0) ? "snap" : "conf"
    // cl([ind,pid-base,tab,base,tabName,ofsName,type,abv])
    let suff=(config.server=="dev")?`-${pid}`:""
//     cl(tabName, ofsName, suff)
//     cl(pid)
//     cl(suff)
//     cl(config.server)
    // TODO process name to make more human readable if does not exist in lookup table
    return formatDatapointName(tabName, ofsName, suff)
    // return tabName + "-" + ofsName+suff
  }

var formatName=(str)=>{
  if(!str)return""
//   cl(str)
  str = str.split("_").map(s=>{
    return s.charAt(0).toUpperCase() + s.slice(1)
  }).join(" ")
  str = str.replaceAll(/([a-z])(?!([a-z]))/g, "$& ").trim();
  str = str.split(" ").map(s=>{
    return s.charAt(0).toUpperCase() + s.slice(1)
  }).join(" ")
  return str
}

var formatDatapointName=(tabName, ofsName, suff)=>{
  // for each name
  tabName = formatName(tabName)
  ofsName = formatName(ofsName)
  return `${tabName} - ${ofsName}${suff}`
}
  


var getParmInfo=(z, c, ix, pid)=>{
  var z1, c1, i1
  let tab=getTable(pid,z)||[]
//   cl(pid)
//   cl(tab)
  //       cl(tab)
  let u = 0
  let k=tab[2]
  switch(tab[1]){
    case 0:// unit data
      z1 = +z;
      c1 = c//240 + u; // zone wide
      i1 = +pid +ix*k;
      break;
    case 1:// snap chan data
      z1 = +z;
      c1 = 40 * u + c; // zone wide
      i1 = +pid;
      break;
    case 2:// snap ecph
      z1 = +z;
      // c1 = 192 + 8 * u + idx; // zone wide
      c1 = +c + 8 * u// + idx; // zone wide
      i1 = +pid;
      break;
    case 3:// conf ecph sensors - idx is tank - I don't think so! ch should be tank, ix is sensor
      z1 = +z;
      // c1 = 192 + 8 * u + idx; // zone wide
      c1 = +c + 8 * u; // + idx; // zone wide
      i1 = +pid + ix * k;
      break;
    case 4:// zone wide, let setpoints
      z1 = +z;
      c1 = 255; // zone wide
      i1 = +pid + ix * k;
      break;
    case 5:// sitewide
      z1 = 255;
      c1 = 0;
      i1 = +pid;
      break;
    case 6:// zone type
      z1 = +z;
      c1 = 255; // zone wide
      i1 = +pid;
      break;
    case 7:// controller settings
      z1 = +z;
      c1 = c//240 + u; // zone wide
      i1 = +pid;
      break;
    default:
      break;
  }
  return [z1, c1, i1];
}

// var getParmInfo=(z, c, ix, pid)=>{
//   //   cl("get parm");
//   return getTable(z, c, ix, pid);
//   //   cl(tab)
// }

var getParmValue=(z, c, ix, pid)=>{
  var p=getParmInfo(z, c, ix, pid)
//   cl(p)
  try{
    if((typeof dbVals.z[p[0]][p[1]][p[2]]) == "object"){
      return dbVals.z[p[0]][p[1]][p[2]].val
    }else{
      return dbVals.z[p[0]][p[1]][p[2]]
    }
  }catch{
    return 0
  }
}

var readValObjType=(val)=>{// only works for numbers@
  if(typeof val == "object"){
    val=val.val
  }
  return (isNaN(val))?val:+val
}

var getChannelTypeId=(gwType,z,c)=>{
  let z0 = z;
  let c0 = (c*1);// 40 * (u*1) +
  //   if (!dbVals.z[z0][c0]){
  //     dbVals.z[z0][c0] = dbVals.z[z0][0];
  //   }
  //   cl(dbVals.z)
  let ch = dbVals.z[z0][c0];
  //   cl(ch)
  let pid = p.PID_BASE_CONF_CHANNELS + pi[1800].channels_configuration["channelType"];
  //   let ty1 = 10 * (typeof ch[pid] == "object") ? ch[pid].val : ch[pid]
  let ty1 = 10 * readValObjType(ch[pid]);
  //       cl([pid, ty1]);
//   cl(ty1)
  switch(ty1){
    case 20:
      pid = p.PID_BASE_CONF_CHAN_DATA + pi[1800].config_channels_configuration["irrigation_mode"];
      ty1 += readValObjType(ch[pid])
      break;
    case 40:
      pid = p.PID_BASE_CONF_CHAN_DATA + pi[1800].config_channels_configuration["light_mode"];
      ty1 += readValObjType(ch[pid])
      break;
    case 60:
      pid = p.PID_BASE_CONF_CHAN_DATA + pi[1800].config_channels_configuration["pump_type"];
      ty1 += readValObjType(ch[pid])
      break;
    case 80:
      pid = p.PID_BASE_CONF_CHAN_DATA + pi[1800].config_channels_configuration["vent_type"];// was vent_mode
      ty1 += readValObjType(ch[pid])
      break;
    default:
      break;
  }
  return ty1
}

var getChannelType=(gwType, z, c)=>{
  //   cl(pi)
  //   cl(dbVals.z.length)
  //   cl([z, c])
  if(!dbVals.z.length) return
  let ty1=getChannelTypeId(gwType,z,c)
    let chType = {};
  chType[0] = "channel_None";
  chType[10] = "channel_On_Off";
  chType[20] = "channel_Irrigation_Scheduled";
  chType[21] = "channel_Irrigation_Accumulated_Light";
  chType[22] = "channel_Irrigation_Cycle";
  chType[23] = "channel_Irrigation_Trigger";
  chType[24] = "channel_Irrigation_Soil_Trigger";
  chType[25] = "channel_Irrigation_VPD";
  chType[30] = "channel_CO2";
  chType[40] = "channel_Light_Supplemental";
  chType[41] = "channel_Light_Scheduled";
  chType[42] = "channel_Light_Cyclic";
  chType[43] = "channel_Light_DLI";
  chType[50] = "channel_Microzone";
  chType[60] = "channel_Supply_Pump";
  chType[61] = "channel_Peristaltic_Recirculating_Pump";
  chType[62] = "channel_Peristaltic_Batch_Pump";
  chType[63] = "channel_Peristaltic_Balance_Pump";
  chType[70] = "channel_Fill_Valve";
  chType[80] = "channel_Vent_Roof";
  chType[81] = "channel_Vent_Retractable_Roof";
  chType[82] = "channel_Vent_Side_Wall";
  chType[90] = "channel_Curtain";
  chType[100] = "channel_Mix_Valve";
  chType[110] = "channel_Proportional_Microzone";
  chType[120] = "channel_PID";
  chType[180] = "channel_Variable_Out";
  
  let suf=""
  if(((ty1%10)==8)&&(gwType==1900)){// if a vent
      suf="_1900"
  }
  let ret=chType[ty1]
  return chType[ty1]+suf;
}

var getChannelInfo=(z,c)=>{
  let ch = dbVals.z[+z][+c]||{};
//   cl(dbVals)
//   cl(c,+c,z,+z)
//   cl(dbVals.z[4])
//   cl(dbVals.z[4][63])
// //   cl(Object.keys(ch).length,ch[507])
  let chBase=p.PID_BASE_CONF_CHANNELS
  let chUsedId = chBase + pi[1800].channels_configuration["used"];
  let chAnalogId = chBase + pi[1800].channels_configuration["isAnalog"];
  let chNameId = chBase + pi[1800].channels_configuration["channelName"];
  let chTypeId = chBase + pi[1800].channels_configuration["channelType"];
  return {
    index: c,
    used: readValObjType(ch[chUsedId]||0),
    analog: readValObjType(ch[chAnalogId]||0),
    name: readValObjType(ch[chNameId]||0),
    type: readValObjType(ch[chTypeId]||0),
  }
}

var getPearlNumOutputs=(bType)=>{
  let numOuts=[
    0,// MB_SLAVE_TYPE_NONE -0
    24,// MB_SLAVE_TYPE_24OUT
    8,// MB_SLAVE_TYPE_8OUT
    4,// MB_SLAVE_TYPE_4OUT
    2,// MB_SLAVE_TYPE_2OUT
    0,// MB_SLAVE_TYPE_EC_PH -5
    2,// MB_SLAVE_TYPE_ANALOG_2OUT
    3,// MB_SLAVE_TYPE_ANALOG_3OUT
    1,// MB_SLAVE_TYPE_ANALOG_1OUT
    5,// MB_SLAVE_TYPE_ANALOG_5OUT
    0,// MB_SLAVE_TYPE_SENSOR_MODULE -10
    0,// MB_SLAVE_TYPE_ANALOG_16INPUT
    8,// MB_SLAVE_TYPE_ANALOG_8IN_8OUT
    0,// MB_SLAVE_TYPE_ANALOG_10IN_DHT
    8,// MB_SLAVE_TYPE_4A_4D_OUTPUT
    0,// MB_SLAVE_TYPE_DTH -15
    0,// MB_SLAVE_TYPE_ANALOG_7IN_DHT -16
    0,// MB_SLAVE_TYPE_DTH_5 -17
    4,// MB_SLAVE_TYPE_4D_DTH -18
    8,// MB_SLAVE_TYPE_8OUT_DTH -19
  ]
  let vNumOuts=[// virtual expansion
    2,// MB_SLAVE_TYPE_PEARL_ANALOG -101
  ]
  if(bType<100){
    return numOuts[bType]
  }else{
    return vNumOuts[bType-101]
  }
}

var getPearlNumIO=(bType)=>{// returns [outs, ins]
  let numIO=[
    [0,0],// MB_SLAVE_TYPE_NONE -0
    [24,0],// MB_SLAVE_TYPE_24OUT
    [8,0],// MB_SLAVE_TYPE_8OUT
    [4,0],// MB_SLAVE_TYPE_4OUT
    [2,0],// MB_SLAVE_TYPE_2OUT
    [0,5],// MB_SLAVE_TYPE_EC_PH -5
    [2,0],// MB_SLAVE_TYPE_ANALOG_2OUT
    [3,0],// MB_SLAVE_TYPE_ANALOG_3OUT
    [1,0],// MB_SLAVE_TYPE_ANALOG_1OUT
    [5,0],// MB_SLAVE_TYPE_ANALOG_5OUT
    [0,0],// MB_SLAVE_TYPE_SENSOR_MODULE -10
    [0,16],// MB_SLAVE_TYPE_ANALOG_16INPUT
    [8,8],// MB_SLAVE_TYPE_ANALOG_8IN_8OUT
    [0,8],// MB_SLAVE_TYPE_ANALOG_10IN_DHT
    [8,0],// MB_SLAVE_TYPE_4A_4D_OUTPUT
    [0,0],// MB_SLAVE_TYPE_DTH -15
    [0,5],// MB_SLAVE_TYPE_ANALOG_7IN_DHT -16
    [0,0],// MB_SLAVE_TYPE_DTH_5 -17
    [4,0],// MB_SLAVE_TYPE_4D_DTH -18
    [8,0],// MB_SLAVE_TYPE_8OUT_DTH -19
    [4,0],// MB_SLAVE_TYPE_ANALOG_4OUT_DTH -20
  ]
  let vNumIO=[
    [2,2],// MB_SLAVE_TYPE_PEARL_ANALOG -0
  ]
  if(bType<100){
    return numIO[bType]
  }else{
    return vNumIO[bType-101]
  }
}

var gmbRegs

var loadGmbRegs=(zInd)=>{
  let gmr="pearl_gmb_registers"
  let regIds={
    gmrRegisterId:getParamId2(1900,gmr,"registerId"),
    gmrCalOfs:getParamId2(1900,gmr,"cal_ofs"),
    gmrCalSlope:getParamId2(1900,gmr,"cal_slope"),
    gmrType:getParamId2(1900,gmr,"gmbType"),
    gmrDataType:getParamId2(1900,gmr,"dataType"),
    gmrFlags:getParamId2(1900,gmr,"flags0"),
  }
  let regMult=pInd[1900].pearl_gmb_registers[2]
  let regs=[]
  for(let i=0;i<64;i++){
    let obj={}
    let id=regIds.gmrDataType+regMult*i
    let dataType=dbVals.z[zInd][240][id]
    if(dataType){
      Object.keys(regIds).forEach(k=>{
        let id=regIds[k]+regMult*i
        obj[k]=dbVals.z[zInd][240][id]
      })
      regs.push(obj)
    }
  }
  gmbRegs=regs
}

var c={
  STCO_STATUS:0x00,// bit 2,3
  STCO_OUTPUT:0x04,
  STCO_CONFIG:0x08,
  STCO_MASK:0x0C,
  ANDI_ANA:0x00,// bit4
  ANDI_DIG:0x10,
  ANDI_MASK:0x10,
}

var gmbGetChannelType=(zInd,boardType,chInd,numOut)=>{
//   cl(boardType,chInd,numOut)
  if(!gmbRegs){loadGmbRegs(zInd)}
//   cl(gmbRegs)
  let chNum=0
  for(let i=0;i<gmbRegs.length;i++){
    if(gmbRegs[i].gmrType==boardType-constant.MB_GMB_0){
      let reg=gmbRegs[i]
//       cl(reg)
      let isOut=(reg.gmrFlags&c.STCO_MASK)==c.STCO_OUTPUT
//       cl(isOut,chNum,chInd)
      if(isOut){
        if(chNum==chInd){
          return (reg.gmrFlags&c.ANDI_MASK)==c.ANDI_ANA?1:0
        }
        chNum++
      }
//       cl(gmbRegs[i])
    }
  }
  return 0
}

var getPearlUsed=(zInd)=>{// only used for outputs
//   cl(dbVals.z[0][240][3896],zInd)
//   console.trace()
  // types: 0:dig, 1:an, 2:d/a
//   cl(zInd)
  let bTypes=[
    0,// MB_SLAVE_TYPE_NONE -0
    0,// MB_SLAVE_TYPE_24OUT
    0,// MB_SLAVE_TYPE_8OUT
    0,// MB_SLAVE_TYPE_4OUT
    0,// MB_SLAVE_TYPE_2OUT
    1,// MB_SLAVE_TYPE_EC_PH -5
    1,// MB_SLAVE_TYPE_ANALOG_2OUT
    1,// MB_SLAVE_TYPE_ANALOG_3OUT
    1,// MB_SLAVE_TYPE_ANALOG_1OUT
    1,// MB_SLAVE_TYPE_ANALOG_5OUT
    1,// MB_SLAVE_TYPE_SENSOR_MODULE -10
    1,// MB_SLAVE_TYPE_ANALOG_16INPUT
    0,// MB_SLAVE_TYPE_ANALOG_8IN_8OUT
    1,// MB_SLAVE_TYPE_ANALOG_10IN_DHT
    2,// MB_SLAVE_TYPE_4A_4D_OUTPUT
    1,// MB_SLAVE_TYPE_DTH -15
    1,// MB_SLAVE_TYPE_ANALOG_7IN_DHT -16
    1,// MB_SLAVE_TYPE_DTH_5 -17
    0,// MB_SLAVE_TYPE_4D_DTH -18
    0,// MB_SLAVE_TYPE_8OUT_DTH -19
    1,// MB_SLAVE_TYPE_ANALOG_4OUT_DTH -20
  ]
  let vBTypes=[
    1,// MB_SLAVE_TYPE_PEARL_ANALOG -0
    3,// Analog Pearl with 16out boards
  ]
  var getChType=(boardType,chInd,numOut)=>{
//     cl(boardType,chInd,numOut)
    if((boardType>=constant.MB_GMB_0)&&
      (boardType<=constant.MB_GMB_0+15)){
        return gmbGetChannelType(zInd,boardType,chInd,numOut)
      }
    var bType
    if(boardType<100){
      bType=bTypes[boardType]
    }else{
      bType=vBTypes[boardType-101]
    }
    switch(bType/*bTypes[boardType]*/){
      case 0:return 0// digital
      case 1:return 1// analog
      case 2:return(chInd>=numOut/2)?1:0
      case 3:return(chInd>=(numOut-2))?1:0
    }
  }
  let xBoards=[]
  let gwType=1900
  let typeId=getParamId2(gwType,"configuration_expansion_boards","boardType")
//   let numOutId=getParamId2(gwType,"configuration_expansion_boards","numOutputs")
  let chIndex=getParamId2(gwType,"configuration_expansion_boards","startChannelIndex")
  let swPosId=getParamId2(gwType, "pearl_xb_snaps","swPos")
  // cl(swPosId)
  let relStateId=getParamId2(gwType, "pearl_xb_snaps","relayState")
  let numInpId=getParamId2(gwType,
    "configuration_expansion_boards","numInputs")
  let numOutId=getParamId2(gwType,
      "configuration_expansion_boards","numOutputs")

//     let addIndex=getParamId2(gwType,"configuration_expansion_boards","address")
  let mult=pInd[1900].config_expansion_boards[2]
  let multSnap=pInd[1900].pearl_xb_snaps[2]
  // cl(multSnap)
  let ch=(dbVals.z[zInd]||{})[240]||{}
//   cl(swPosId)
//   cl(ch)
//   cl(ch[swPosId])
//   cl(typeId,mult)

//   cl(dbVals.z[0][240][3896],zInd)
  for(let i=0;i<30;i++){// go through xBoards
//     cl(i,ch[typeId+i*mult]||0)
    let bType=+ch[typeId+i*mult]||0
//     cl(bType, typeId+i*mult)
    xBoards.push({
      type:bType,
      numIn:+ch[numInpId+i*mult],
//       (getPearlNumIO(bType)||{})[1],// +ch[numOutId+i*mult]||0,
      numOut:+ch[numOutId+i*mult],
//       (getPearlNumIO(bType)||{})[0],// +ch[numOutId+i*mult]||0,
      chInd:+ch[chIndex+i*mult]||0,
      swPos:+ch[swPosId+i*multSnap]||0,
      relState:+ch[relStateId+i*multSnap]||0,
    })
  }
//   cl(xBoards)
  let ret=[]
//   cl(xBoards)
  xBoards.forEach(x=>{
//     if(x.type!=0)(cl(x))
    if((+x.numOut)>0){
      if(x.numOut > 32){
//         cl(x.numOut)
        x.numOut=32}
      let swPos=+x.swPos
      let relState=+x.relState
      for(let i=0;i<x.numOut;i++){

//         cl(i)
        ret.push({
          chInd:x.chInd+i,
          type:getChType(x.type,i,x.numOut),
          swPos:swPos&0x01,
          relState:relState&0x01,
        })
        swPos=swPos>>1
        relState=relState>>1
//         ret.push(x.chInd+i)
      }
    }
  })
//   if(zInd==2){
//     cl(xBoards)
//     cl(ret)
//   }
  ret=ret.sort((a,b)=>{
    if(a.chInd>b.chInd){return 1}
    if(a.chInd<b.chInd){return -1}
    return 0
  })
    // HydroRoot 16 only: legacy analog mapping can mark the last two outputs as analog; HR16 is all digital.
  const ziHr = globs?.zonesInfo?.info?.find(z =>
    z.siteZoneIndex === zInd &&
    (z.siteId === globs?.userData?.session?.siteId || z.siteId === globs?.userData?.siteLoaded))
  if (ziHr?.zoneId && isHydroRoot16(ziHr.zoneId) && ret.length >= 2) {
    for (let i = ret.length - 2; i < ret.length; i++) {
      ret[i] = { ...ret[i], type: 0 }
    }
  }
//   cl(ret)
//   cl(ret[0])
  return ret
}

var get800Used=(zInd,zInfo)=>{
  var get800Expansion=()=>{
    let boardTypeId=getParamId2(800,"igCX","boardType")
    let channelStartId=getParamId2(800,"igCX","channelStartIndex")
    if(!dbVals.z||!dbVals.z[zInd]){return[]}
    let exps=[...Array(12).keys()].map(i=>{
      return {
        boardType:dbVals.z[zInd][i][boardTypeId]||0,
        chStart:dbVals.z[zInd][i][channelStartId],
      }
    })
    return exps
  }
  let used={};
  [...Array(8).keys()].forEach(// add the 8 base channels
    i=>{
      used[i]=1
    })
  let exps=get800Expansion()
  exps.forEach(x=>{// add the exapanion boards
    if(x.boardType==3){
//       cl(x)
      for(let i=0;i<4;i++){
        let i2=i+8+x.chStart
        used[i2]=1
      }
    }
  })
  let u2=Object.keys(used)// just the keys
  let u3=u2.map(u=>{return +u})
    .sort((a,b)=>{// to int, and sort
    if(a>b){return 1}
    if(a<b){return -1}
    return 0
  })
  let u4=u3.map(u=>{return{chInd:u}})
//   cl(u4)
  return u4
}

var getDbId=(tabName,colName,index)=>{
  let tabInfo=pInd[1900][tabName]
  return tabInfo[0]+pi[1900][tabName][colName]+index*tabInfo[2]
}

var getDbVal=(tabName,colName,zInd,chan,index)=>{
//   cl(dbVals)
//   let tabInfo=pInd[1800][tabName]
//   let id=tabInfo[0]+pi[1800][tabName][colName]+index*tabInfo[2]
  return dbVals.z[zInd][chan][getDbId(tabName,colName,index)]
}

// FUINumerical's min/snap-up behaviour on the sensor-tile alarm form.
//   Temperature  -> default 2 (unit-as-shown, per product req)
//   Humidity     -> default 5
//   anything else -> default 1
// FUINumerical separately enforces a hard input floor of 1.
var getSensorDeadbandRule=(sensorKey)=>{
  let s=(sensorIds||{})[sensorKey]
  let g=s?.unitGroup
  // Temperature: 2 is a degrees DELTA (deadband), not an absolute temp.
  if(g=="Temperature"){
    return {deadbandDefault:2,
      deadbandTooltip:"Default deadband for inside/outside temperature is 2\u00B0."}
  }
  if(g=="Humidity"){
    return {deadbandDefault:5,
      deadbandTooltip:"Default deadband for inside/outside humidity is 5%."}
  }
  return {deadbandDefault:1,
    deadbandTooltip:"Minimum deadband is 1."}
}


var getAuxGraphing=(siteId,zInd)=>{
// returns keyVal, with id as key, name, default as props
// find the aux var, pers, alarms that have graphing enabled
  let ret={}
  for(let i=0;i<64;i++){
    if(i<32){
      if(getDbVal("config_aux_alarms","allowGraphing",zInd,240,i)){
        ret[`e0aa${i}`]={
          name:getDbVal("config_aux_alarms","alarmName",zInd,240,i),
          default:[[0,1]],
        }
      }
      if(getDbVal("config_aux_persistent_variables","allowGraphing",zInd,240,i)){
        ret[`e0ap${i}`]={
          name:getDbVal("config_aux_persistent_variables","variableName",
            zInd,240,i),
          default:[[0,100]],
        }
      }
    }
    if(getDbVal("config_aux_variables","allowGraphing",zInd,240,i)){
      ret[`e0av${i}`]={
        name:getDbVal("config_aux_variables","variableName",zInd,240,i),
          default:[[0,100]],
      }
    }
  }
  return ret
}


var getChannelsInfo=(z,zoneControllers,gwType)=>{
//   cl(z.zoneControllers)
  if(!gwType){gwType=1800}
  var pearlUsed
  if(gwType==1900){pearlUsed=getPearlUsed(z)}
//   cl(pearlUsed)
  let chBase=p.PID_BASE_CONF_CHANNELS
  let chUsedId = chBase + pi[1800].channels_configuration["used"];
  let ret=[]
//   cl(dbVals.z[+z])
//   cl(chUsedId)
  for(let c=0;c<160;c++){
    let u=0//Math.floor(c/40)
//     cl(dbVals.z)
//     cl(c)
//     cl([z,c])
    let used=(gwType==1900)?
      pearlUsed[c]||false:
      readValObjType(((dbVals.z[+z]||{})[c]||{})[chUsedId])


//     cl([z,c,used])
    if(used&&(zoneControllers[u]!=0)){
      ret.push(getChannelInfo(z,c))
    }
  }
//   cl(ret)
  return ret
}

/********************** End values and functions for Widgets **********************************/

const po = function (method, body){
  var ret = {
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, same-origin, *omit
    headers: {
      'user-agent': 'Mozilla/4.0 MDN Example',
      'content-type': 'application/json',
      'authorization': 'Bearer ' + globs.token,
    },
    method: method, // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, cors, *same-origin
    redirect: 'follow', // *manual, follow, error
    referrer: 'no-referrer', // *client, no-referrer
  }
  if (body && (body !== "")) ret.body = body ;
  return ret ;
}

function doGetPost(server, purl, cmd, func, params){
  cl([server, purl, cmd, func, params]);
  return new Promise((res, rej)=>{
    let url = constant.urls[server] + "/" + purl;
    let pv = ((cmd === "POST") || (cmd === "PUT")) ?
      JSON.stringify(params.Post) : "";
    let httpObj = po (cmd, pv) ;
    return fetch(url, httpObj).then(
      response => {
//         response.text().then(r=>{cl(r)});
        response.json().then(
          resp=>{
            if(func)func(resp, params);
            res(resp);
          }
        );
      }, e=>{rej(e)}
    );
  })
}

/****************** WebSocket Functions *************************/

var wsArr = {}; 

var wsOnOpen=(r, ws)=>{
  showTime("wsOpen")
  cl("got open");
//   cl(wsArr[ws.wsID].timeOut);
//   clearTimeout(wsArr[ws.wsID].timeOut);
  wsArr[ws.wsID].state="ok";
  r({result: "ok"});
//   cl(globs)
//   cl(globs.userData.session.zoneId)
//   cl(globs.userData.session)
//   cl(globs.userData)
  setTimeout(x=>setClientId(globs.userData.session?.zoneId),100)

}

var wsOnClose=(ws)=>{
  cl("USA ws on close")
  wsArr[ws.wsID]=null;
//   cl("on close");
}

var wsOnError=(ws,wsID,uri,r,e)=>{
//   clearTimeout(wsArr[ws.wsID].timeOut);
  globs.events.publish("wsServerOK",false)
  globs.serverOK=false
  setTimeout(()=>doOpenWS(wsID,uri,r,e),5000)
//   cl(e);
//   e({result: "Web Socket Error"});
}

var timeoutError=(e)=>{
  e({result: "Web Socket Timeout Error"});
}

var waitForSocketOpen=(wsID, r)=>{
//   cl("wait for socket open: " + wsID);
  if((wsArr[wsID]||{}).state==="ok") {
//     clearInterval(wsArr[wsID].waitConnect);
    r({result: "ok"});
  }else{
    setTimeout(()=>waitForSocketOpen(wsID, r), 1000);
  }
}

var openWebSocket=(wsID, uri)=>{
//   cl(`Open ${wsID}, ${uri}`)
/* connect to a new web socket, add the callbacks, and
initialize the entry in the web socket array
set a timeout in case the connection just hangs

This gets more difficult when *two* callers are both trying to open the websocket*/
  return new Promise((r, e)=>{
    if(wsArr[wsID]){// this socket is open, or connecting
//       cl("is open")
//       cl(`Open ${wsID}, ${uri}`)
      waitForSocketOpen(wsID, r);
//       if(wsArr[wsID].state == "connecting"){
//         wsArr[wsID].waitConnect=setInterval(()=>waitForSocketOpen(wsID, r), 1000);
//       }else{
//         r({result: "ok"});
//       }
    }else{
      cl(`Need to Open ${wsID}, ${uri}`)
//       cl(uri);
//       cl(config)

      doOpenWS(wsID,uri,r,e)

//       let ws = new WebSocket(uri);
//       ws.onopen = v=>wsOnOpen(r, ws);// this is where the promise returns!
//       ws.onclose = v=>wsOnClose(ws);
//       ws.onmessage = v=>wsOnMessage(v, ws);
//       ws.onerror = v=>wsOnError(e, ws);
//       ws.wsID = wsID;

//       let to = setTimeout(err=>timedOut("Web Socket"), 5000);
//       wsArr[wsID]={ws: ws, key: 0, callBacks: {}, timeOut: to, state: "connecting"};
    }
  });
}

var doOpenWS=async(wsID,uri,r,e)=>{
  cl("do open WS to USA")
//   cl(constant)
//   cl(config)
  var ws
  ws = new WebSocket(uri);
  ws.onopen = v=>wsOnOpen(r, ws);// this is where the promise returns!
  ws.onclose = v=>wsOnClose(ws);
  ws.onmessage = v=>wsOnMessage(v, ws);
  ws.onerror = v=>wsOnError(ws,wsID,uri,r,e);
  ws.wsID = wsID;
  wsArr[wsID]={ws: ws, key: 0, callBacks: {}, /*timeOut: to, */state: "connecting"};
//   return ws
}

var initWebSocket=async(wsID="usa")=>{
//   cl("init USA web socket");
//   cl(constant.wsUsaUrl);
  return await openWebSocket(wsID, constant.wsUsaUrl);// a promise//"wss://gene.c2.link4cloud.com:constant.usaWebSocket"
}

var checkUsaWebSocket=()=>{
  if(wsArr["usa"]){return}
  if(!constant.wsUsaUrl){return}
  initWebSocket()
}

setInterval(checkUsaWebSocket,5000)

var toClient=(msg)=>{
//   cl(msg)
  globs.events.publish("toClient",msg)
}

var onCmdMessage=(msg,ws)=>{
//   cl(msg)
  switch(msg.cmd){
    case "toClient":
      toClient(msg)
      break
    case "syncStat":
      updateSyncStat(msg.cmd,msg)
      break
    default:
      globs.events.publish(msg.cmd,msg)
      break
  }
//   switch(msg.cmd){
//     case "userNotification":
//       globs.events.publish("userNotification",msg)
//       break
//     default:
//       break
//   }
}

var wsOnMessage=async(msg, ws)=>{

/* get the JSON object, and the callbacks for this keys
clean up the callback array, and use the success callback to return the object*/
//   cl(msg)
//   cl(msg.data.length)
  clearTimeout(wsArr[ws.wsID].timeOut);

  var mo
//   cl(msg)
//   cl(typeof(msg.data))
  if(typeof(msg.data)!="string"){// added
    mo=await uncompress(msg.data)
  }else{
    mo = JSON.parse(msg.data);
  }
//   cl(mo)

  let msgObj=mo//JSON.parse(mo);
  if(msgObj.cmd!="sRest"){return onCmdMessage(msgObj,ws)}
  let wsInfo = wsArr[ws.wsID];
  globs.events.publish("wsServerOK",true)
  globs.serverOK=true
  clearTimeout(wsInfo?.timeOut);
//     cl(msgObj);
//   cl(wsInfo.callBacks);
  if(typeof(msgObj.cwsKey)!="undefined"){
    let cb=wsInfo?.callBacks[msgObj?.cwsKey]
    if(cb){
      let [r, e] = wsInfo?.callBacks[msgObj?.cwsKey];
      delete wsInfo.callBacks[msgObj.cwsKey];
      r(msgObj);
    }
  }
}

var sendWebSocketMessage=(wsID, msgObj)=>{
/* this is the bare minimum of sending a webSocket message
wsID is the id of the socket - just 'usa' for now.
wsArr holds info on all out web sockets.
*/
//   cl(`send WS Message ${msgObj.uri}`)
//   cl(msgObj)
  wsArr[wsID].ws.send(JSON.stringify(msgObj));
}

var webSocketTransaction=(wsID, msgObj)=>{// msgObj must have a cmd field
/* this will attach a key to the message, to connect the response with the request.
This will return a promise*/
  return new Promise((r, e)=>{
    let wsInfo = wsArr[wsID];
    wsInfo.callBacks[wsInfo.key]=[r, e];
    let msgObj2=Object.assign({cwsKey: wsInfo.key++}, msgObj);
//     wsInfo.timeOut = setTimeout(err=>timeoutError(e), 5000);
    sendWebSocketMessage(wsID, msgObj2);
//     cl("sent");
  });
}

var cache={
  makeUri:(wsID,msgObj,keys)=>{
    let userId=globs.userData.session?.userId||"userId"
    let accountId=globs.userData.session?.accountId||"accountId"
    let keyStr=(keys||[]).join("/")
    if(keys.length){keyStr+="/"}
    return `/${wsID}${msgObj.uri}/${msgObj.method}/${accountId}/${keyStr}${userId}`
  },
  check:async(wsID,msgObj,keys,r,e)=>{
    let uri=cache.makeUri(wsID,msgObj,keys)
//     if(wsID=="cont"){cl(`check ${uri}`)}

    let res=await ufs.get(uri)
//     cl(res)
    if(res&&res.length){
      r(JSON.parse(res))
      return true
    }else{
      return false}
  },
  save:(wsID,msgObj,keys,res)=>{
    let uri=cache.makeUri(wsID,msgObj,keys)
//     cl(`save ${uri}`)
    ufs.set(uri,JSON.stringify(res))
  },
}

var badWsTrans=(msgObj)=>{
  cl(`Timeout Error in WS Transaction to: ${msgObj.uri}`)
}

var doWsTrans=(wsID,msgObj,useCache,doPromise,keys,r,e)=>{
  let now=getTime()
  let access={uri:`b_${msgObj.uri}`,method:msgObj.method,start:now}
  initWebSocket(wsID).then(
    re=>{
      let tmOut=setTimeout(e=>badWsTrans(msgObj),5000)
      webSocketTransaction(wsID, msgObj).then(
        res=>{
//           cl(res)
          clearTimeout(tmOut)
          if(res.result!="ok"){
            switch(res.result){
              case "badUri":
                cl(`WS Transaction Error, Bad Uri: ${msgObj.uri}`)
                break
            }
          }
          access.elapse=getTime()-access.start
          saveBrowserAccess(access)
          if(useCache){cache.save(wsID,msgObj,keys,res)}
          if(doPromise){r(res)}
        }, 
        err=>{e(err)}
      );
    },
    er=>{e(er)}
  );
  
}

var wsTrans=(wsID, msgObj,useCache=false,keys=[])=>{// this makes sure the socket is open
  return new Promise(async(r, e)=>{
    if(useCache&&(!globs.disableCache)){
      let res=await cache.check(wsID,msgObj,keys,r,e)
      if(res){
        doWsTrans(wsID,msgObj,useCache,false,keys,r,e)
        return}
    }
    doWsTrans(wsID,msgObj,useCache,true,keys,r,e)
  });
}

var loadWsTrans=async(parms)=>{
  return await wsTrans("usa", {cmd: "cRest", uri: parms.uri, 
    method: parms.method||"retrieve", sessionId: globs.userData.session.sessionId, 
    body: parms.body})
}
  
var webSocketREST=(wsID, uri, method, body=null)=>{
/* uri has two parts: endpoint, and params
endpoint is a normal uri: "/sites"
params is an object. the attributes are the values that are needed by the endpoint
This also needs to handle the secure transactionsif the uri begins with /s, then we need to include the 
access token. If that fails, try the refresh token. If that fails, try to login again
RememberMe should just be a 100year refresh token
*/
  let msgObj={
    cmd: "cRest",
    uri: uri,
    method: method,
    body: body
  };
  return webSocketTransaction(wsID, msgObj);
}

/****************** End WebSocket Functions *************************/

/****************** Material UI Functions *************************/

var handleClickShowPassword=(props)=>{
  cl(props);
  props.passwordType=(props.passwordType === "password") ? "text" : "password";
}

var inputField=(props)=>{
//   cl("input");
//   cl(props);
  if(props.type === "password"){
    return(
      <div style={{padding: 10}}>
      <InputLabel htmlFor="unknown">{props.title}</InputLabel>
      <Input
      onChange={props.onChange}
      type={props.passwordType}
      value={props.value}
      id={"if-" + props.field}
      endAdornment={
        <InputAdornment position="end">
        <IconButton
        aria-label="toggle password visibility"
        onClick={e=>handleClickShowPassword(props)}
        edge="end"
        >
        {props.passwordType !== "password" ? <Visibility /> : <VisibilityOff />}
        </IconButton>
        </InputAdornment>
      }
      />
      </div>
      
    );
  }else{
    return(
      <div style={{padding: 10}}>
      <InputLabel htmlFor="unknown">{props.title}</InputLabel>
      <Input
      onChange={props.onChange}
      value={props.value}
      id={"if-" + props.field}
      />
      </div>
    );
  }
}

/****************** End Material UI Functions *************************/

/********************** Login ******************************/

var logout=()=>{
//   cl("logout");
	if(globs?.userData?.session){
	  let logoutObj={cmd: "cRest", uri: "/o/users/login", method: "delete", 
		body: {sessionId: globs.userData.session.sessionId}
	  };
	  globs.userData.session=null;
	  wsTrans("usa", logoutObj).then(r=>{
		setLoggedIn(false);
	  });
	}
  
//   initWebSocket().then(r=>{
//     let body={sessionId: globs.userData.session.sessionId};
//     let msgLogOut = {cmd: "cRest", uri: "/o/users/login", method: "delete", body: body};
//     webSocketTransaction("usa", msgLogOut).then(
//       r=>{
//         setLoggedIn(false);
//       },
//       e=>{cl(e)}
//     );
//   });
}

var loginoutUsa=()=>{
// log in or out
  if(globs.userData.loggedIn){
    cl("logged in")
//     cl(dbVals)
    dbVals.z=[]
    dbVals.gotSite=false
    dbVals.initted=false
//     cl("logout");
//     cl(globs.userData.session.sessionId);
    logout();
    history.push("/usa/login");
  }else{
    history.push("/usa/login");
  }
//   cl("do login");
}

var setLoggedIn=(loggedIn)=>{
//   cl("set logged in");
  globs.userData.loggedIn=loggedIn;
//   if(!globs.menuBar) globs.menuBar={};
  if(globs.menuBar){globs.menuBar.setLoggedIn(loggedIn);}
  
}

var saveSession=(session)=>{
  saveLocalStorage("session", JSON.stringify(session));
  saveLocalStorage2("session", JSON.stringify(session));// to enable tab sharing
}

var saveTokens=(access, refresh, session)=>{// after activate or login
//   cl("saveTokens")
//   cl([access, refresh, session])
//   cl("save")
  if(!globs.userData) globs.userData={};
  globs.userData.accessToken=access;
  globs.userData.refreshToken=refresh;
  globs.userData.session=session;
  invalidateAccountCaches()// new session/account: force fresh fetch of globs
  saveLocalStorage("accessToken", access);
  saveLocalStorage("refreshToken", refresh);
  saveSession(session)
//   saveLocalStorage("session", JSON.stringify(session));
  setLoggedIn(true);
}

var invalidateAccountCaches=()=>{
// fresh fetch of globs data on login/logout
  let infos=["accountInfo","sitesInfo","zonesInfo","subscriptionInfo","alarmsInfo",
    "gatewaysInfo","addedSensorsInfo","privsInfo","mbInfo","usersInfo","presetsInfo"]
  infos.forEach(i=>{if(globs[i]){globs[i].got=false}})
  if(globs.zonesInfo){globs.zonesInfo.sz2z=null}
}

// need mobile specific version!!!

var getUId=(deviceId=null)=>{
//   cl("save")
//   cl(deviceId)
  if (deviceId) {
    cl("saving passed in deviceId")
    saveLocalStorage("deviceId",deviceId)
  } else {
    deviceId = getLocalStorage("deviceId")
//     cl("found deviceId in storage")
    if (!deviceId) {
      cl("making new deviceId")
      deviceId=getRandomString(16)
      saveLocalStorage("deviceId",deviceId)
    }
  }
//   cl(deviceId)
  return deviceId
}

var loadTokens=(session=null)=>{
//   cl("load tokens")
//   console.trace()
//   cl("save")
  if(!globs.userData) globs.userData={};
  globs.userData.accessToken=getLocalStorage("accessToken");
  globs.userData.refreshToken=getLocalStorage("refreshToken");
  getUId()
//   cl(globs.userData.uId)
  try{
//     cl("get session")
    if (session) {
      globs.userData.session = session
      saveLocalStorage("session", globs.userData.session)
    } else {
      globs.userData.session=JSON.parse(getLocalStorage("session"));
//       cl(globs.userData.session.features)
    }
    return true
  }catch{
    globs.userData.session={};
    return false
  }
}
var loggingInResolves=[];

var doCheckLoggedIn=(r, e)=>{// this is called from MainBar
//   cl(globs.userData.loggedIn)
  if(globs.userData.loggedIn){
    r(true)
    return
  }
//   cl("still")
  loggingInResolves.push(r);// add it to the list
  if(loggingInResolves.length==1){// first time
//     cl("get")
    let body={sessionId: globs?.userData?.session?.sessionId};
    let msgCheckLoggedIn = {cmd: "cRest", uri: "/o/users/login", method: "retrieve", body: body};
//     cl(msgCheckLoggedIn)
    wsTrans("usa", msgCheckLoggedIn).then(re=>{
//       cl(re)
      if(re.result){
        let str=JSON.stringify(re.session)
        saveLocalStorage("session", str);
        saveLocalStorage2("session", str);// forced to localStorage, not session
//         cl("save session")
        globs.userData.session=re.session
//         cl(re.session.features)
        saveBrowserAccess("/browser/usaUtils/doCheckedLogin/line1245")
//         cl(globs.userData)
      }else{
        localStorage.removeItem("session");// session is no good
      }
//       cl(re.session)
      setLoggedIn(re.result);
//       globs.userData=null// why is this here?
      loggingInResolves.forEach(liR=>liR(re.result));
      loggingInResolves=[];
    });
  }
}

var resizePublish=()=>{
  globs.userData.resizeTimeout=null
  globs.events.publish("windowResize",globs.userData.winSize)
//   cl("resize")
}

var resizeEvent=()=>{
  globs.userData.winSize=[window.innerWidth, window.innerHeight]
  if(!globs.userData.resizeTimeout){ 
    globs.userData.resizeTimeout=setTimeout(resizePublish,1000)
  }
}

var getWindowResize=()=>{
//   cl("getWindowResize")
  globs.userData.winSize=[window.innerWidth, window.innerHeight]
  window.addEventListener('resize', resizeEvent);  
}

var checkLoggedIn=(session = null)=>{// if logged in, get session data, otherwise, mark userData.loggedIn false
//   console.trace()
  if(!globs?.userData?.session?.sessionId && !loadTokens(session)) {return}
  getWindowResize()
  return new Promise((r, e)=>{
    setTimeout(t=>doCheckLoggedIn(r, e), 0);// so that a page can "logout" before checkLoggedIn
  })
/*this needs to be callable from multiple places, as a promise, 
it will only do the actual check once, and then resolve all the promise requests
*/
  
  
// //   cl(globs.userData.session.sessionId);
//   initWebSocket().then(r=>{
//     let body={sessionId: globs?.userData?.session?.sessionId};
//     let msgCheckLoggedIn = {cmd: "cRest", uri: "/o/users/login", method: "retrieve", body: body};
//     webSocketTransaction("usa", msgCheckLoggedIn).then(// this will return tokens, like login, then redirect
//     r=>{
//       cl(r);
//       setLoggedIn(r.result);
//     },
//     e=>{cl(e)}
//     );
//   });
}

/********************** End Login ******************************/

/********************** Form Helper Functions  ******************************/
var validEmail=(email)=>{
  let atPos = email.indexOf("@");
  let perPos = email.lastIndexOf(".");
  return ((atPos > 0) && (perPos > atPos));
}

/********************** End Form Helper Functions  ******************************/

var tryIt=()=>{
  cl("try");
}

var colorSquare=(col, size, key=1, onClick=null)=>{
    return(
      <div key={key} style={{width: size, height: size, marginLeft: 10, display: "inline-block", verticalAlign: "middle", backgroundColor: col
      }} onClick={onClick}/>
    )
  }
  
var doGetPostBasic=(url, method, body=null, type='')=>{
  return new Promise((res, rej)=>{
    let options={
      method: method,
      headers: {},
    }
    if(body) options.body = body;
    if(type) options['content-type']=type
    return fetch(url, options).then(
      r=>{
        res(r)},
      e=>{
        res({json:e=>{return {result:"error"}}})
      }
    )
  })
}

var getHomeDashboard=async()=>{
//     cl(this.state)
//     cl(this.props)
//     cl(globs.userData.session)
    let r = await wsTrans("usa", {cmd: "cRest", uri: "/s/sites", method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {siteId: globs.userData.session.siteId}})
//     cl(r)
    if(r.data[0]&&r.data[0].homeDashboard){
      return r.data[0].homeDashboard
    }else{
      r = await wsTrans("usa", {cmd: "cRest", uri: "/s/dashboards", method: "retrieve2", sessionId: globs.userData.session.sessionId,
        body: {a: globs.userData.session.accountId}})
      cl(r)
      if(!r.data.length){
        r = await wsTrans("usa", {cmd: "cRest", uri: "/s/dashboards", method: "retrieve2", sessionId: globs.userData.session.sessionId,
          body: {u: globs.userData.session.userId}})
        cl(r)
      }
    }
    if(r.data[0]){return r.data[0].i}
  }

  var getLinkUrl=(parms)=>{
    let url=parms.link
    if(!url){return""}
    let end=url.lastIndexOf("/")
    let suff=url.substr(end);
    let p=suff.split("-")
    if(p.length==4){return url}
    let zci=parms.zci
    return `${url}/${zci[0]}-0-${zci[1]}-${zci[2]}`
  }
  
  var removeAClass=(curClass,remClass)=>{
    return curClass.replace(`${remClass} `,"")
  }
  
  var addAClass=(curClass,addClass)=>{
    cl(addClass)
    return curClass+`${addClass} `
  }
  
  var hasAClass=(curClass,checkClass)=>{
    return curClass.indexOf(` ${checkClass} `)>=0
  }
        
  var toggleAClass=(curClass,togClass)=>{
    let hasClass=hasAClass(curClass,togClass)
    curClass=removeAClass(curClass,togClass)
    if(!hasClass){
      curClass=addAClass(curClass,togClass)
    }
    return curClass
  }
  
//   var idToTabInd=(id,zType)=>{
// //     cl(id,zType)
//     for (let i = 0 ; i < tableBases2[zType]?.length ; i++){
//       if(tableBases2[zType][i][0] > id) return i - 1;
//     }
//   }
  
  // var tabIndToName=(base, zType=1800)=>{
  //   for(let i=0; i<Object.keys(pInd[zType])?.length; i++){
  //     let k=Object.keys(pInd[zType])[i];
  //     if(pInd[zType][k][0]==base)return k
  //   }
  // }
  
  // var tabOffsetToName=(tab, ofs, zType=1800)=>{
  //   // cl([tab, ofs])
  //   for(let i=0; i<Object.keys(pi[zType][tab])?.length; i++){
  //     let k=Object.keys(pi[zType][tab])[i]
  //     if(pi[zType][tab][k]==ofs) return k
  //   }
  // }
  
//   var getDatapointName=(pid,zType)=>{
// //     console.trace()
//     if(!pid) return ""
// //       cl(pid)
//     let ind = idToTabInd(pid,zType)
// //     cl(ind,zType)
//     let tab=(tableBases2[zType][ind])
//     if (!tab) return ""
//     let base=tab[0]
//     let tabName=tabIndToName(base)
//     let ofsName=tabOffsetToName(tabName, pid-base)
//     let type=tab[1]
//     let abv = (tabName.indexOf("snap")>=0) ? "snap" : "conf"
//     let ret=abv + "-" + ofsName
//     return ret
//   }
  
  
//   var getLine=()=>{
// //     cl(callStack())
//     cl("get")
//     let er2={}
//     Error.captureStackTrace(er2)
//     let lines=er2.stack.split("\n")
//     cl(lines)
// //     cl(er2.stack)
// //     cl(typeof(er2.stack))
// //     cl(er2)
//     return
//     
//     let er=new Error()
//     let st=Error.captureStackTrace(er)
//     cl(er)
//     cl(st)
//     var orig = Error.prepareStackTrace;
//     cl(orig)
//     Error.prepareStackTrace = function(_, stack){ return stack; };
//     cl("next")
//     return
//     var err = new Error;
// //     Error.captureStackTrace(err, arguments.callee);
// //     var stack = err.stack;
// //     Error.prepareStackTrace = orig;
// //     return stack;
//     
//   }

  var browserAccess={last:0,arr:[]}
  var localAccess=[]
  
  
  var saveBrowserAccess=(msg)=>{
// if now is > 10 secs after last, then write it, and update last
// otherwise, just push to arr
// can call with null msg to flush it
//     cl(msg)
    let now=getTime()
    if(typeof(msg)=="string"){
      msg={
        uri:msg,
        method:"bCreate",
        start:now,
      }
    }
    browserAccess.arr.push(msg)
    let laLen=localAccess.length
    if(laLen>300){localAccess=localAccess.slice(laLen-200)}
    localAccess.push(msg)
    if(now-browserAccess.last>10){
      let ba={last:now,arr:browserAccess.arr.slice(0)}
      browserAccess={last:now,arr:[]}
//       cl("write")
//       let ba=Object.assign({},browserAccess)
//       browserAccess.last=now
      wsTrans("usa", {cmd: "cRest", uri: "/s/accesses", method: "create", 
        sessionId: globs?.userData?.session?.sessionId, body: ba})
    }
  }

  var makeOpts=(vals)=>{
    return vals.map((v,i)=>{return(
      <option key={i} value={v.v}>{v.t}</option>
    )})
  }

  var log2=Math.log(2)
  
  var getPe=(tFrom,tTo)=>{
    let int=(tTo||0)-(tFrom||0)
    if(int<1000){return 0}
    return(Math.floor(Math.log(int)/log2-9))
  }

  var getTzo=(zone)=>{
    let da=new Date()
    let tzId=getParamId2(zone?.gatewayType,"pearl_config","time_TimeZoneShift_mins")
    // cl(tzId)
    let tzo=((dbVals.z[zone?.siteZoneIndex||0]||{})[240]||{})[tzId]||(0-da.getTimezoneOffset())
    // cl(tzo)
    return tzo
  }

  var getDst=(zone)=>{
    let dstId=getParamId2(zone?.gatewayType, "zone_configuration_settings", "Daylight Savings Time")
    let dst_enabled = ((dbVals.z[zone?.siteZoneIndex||0]||{})[255]||{})[dstId]||0
    return dst_enabled
  }

  var getTZIndicator=(tzo)=>{
    // cl(tzo)
    let hr=Math.floor(tzo/60)
    let mn=tzo%60
    if(hr>=0){hr=`+${hr}`}
  //       cl(hr,mn)
    return `(UTC${hr}:${az(mn,2)})`
  }

  var updatePearlImage=async(parent,clientId)=>{
//     cl("update pearl")
//     let st=this.state
//     cl("get")
    let query={clientId:clientId}
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlScreen", method: "retrieve",
      sessionId: globs.userData.session.sessionId, body:
      query})
//     cl("got")
    if(!res.data.image){return}
    let buf=res.data.image.buf.data
//     cl(buf.length)
    let count=(+res.data.count)||0
    if(count>2){count=2}
    parent.framesPerSec=0.80*parent.framesPerSec+.20*(5*count)// 5 sec avg
    let ctx=parent.canvas.getContext("2d")
    ctx.willReadFrequently=true
    let imgData=ctx.getImageData(0,0,128,64)

    for(let i=0;i<8;i++){// 8 tiles vertically
      for(let j=0;j<16;j++){// 16 tiles across
        for(let k=0;k<8;k++){// down the lines of the tile
          let index=128*i+8*j+k// index of the line
          if(index<1024){
            let byte=buf[index]
            for(let l=0;l<8;l++){// each tile height is 4k
              let dest= 4096*i+32*j+4*k+512*(7-l)
              imgData.data[dest+0]=0// red
              imgData.data[dest+3]=0xFF// alpha
              if(byte&0x80){
                imgData.data[dest+1]=0xFF// blue
                imgData.data[dest+2]=0xFF// green
              }else{
                imgData.data[dest+1]=0
                imgData.data[dest+2]=0
              }
              byte=byte<<1
            }
          }
        }
      }
    }

    ctx.putImageData(imgData,0,0)
//     cl("return")
//     let url=parent.canvas.toDataURL("image/png")
//     return url
//     cl(url)
    parent.canvasUrl=parent.canvas.toDataURL("image/png")
//     this.setState({upd:(st.upd||0)+1,fps:this.framesPerSec})

  }

var spGetNames=(gwType, zoneIndex)=>{
    let nameId=getParamId2(gwType,"configuration_setpoints","name")
    if(!gwType){return[]}
    let mult=pInd[gwType].config_setpoints[2]
    let names=[]
    // cl("nameId=", nameId, "mult=", mult)
    for(let i=0;i<8;i++){
      let pid=nameId+mult*i
      // cl(zoneIndex)
      if(!dbVals.z[zoneIndex][255][pid]){
        dbVals.z[zoneIndex][255][pid] = ""
      }
      names.push(dbVals.z[zoneIndex][255][pid].toString().toLowerCase())
    }
    // cl({names})
    return names
  }
  var cnvNum=(val)=>{
    if(!isNaN(val)){val=+val}
    return val
  }
  var sendValue=async(pid,val, gwType, zoneIndex)=>{
    let arr=[{
      z:zoneIndex,
      c:255,
      i:pid,
      d:val,
      f:1,
      t:getTime(),
    }]
    cl("arrr", arr)
    return await sendArray(arr,false,gwType,0,false)
  }
var setColNameSetpoint = (column) => {
  // Replace any occurrence of "set point", "setpoints", or "set points" with "setpoint"
  let col = column.toLowerCase().trim();
  const arr = ["set point", "setpoints", "set points"];
  arr.forEach((el) => {
    col = col.replaceAll(el, "setpoint");
  });
  return col;
}

 var changeSetpoint=async(args, gwType, zoneIndex)=>{
      let ids={
      "enable":"enabled",
      "setpoint name":"name",
      "start time":"startTimeOfDay",
      "heat setpoint":"heatSetpoint",
      "heat":"heatSetpoint",
      "cool setpoint":"coolSetpoint",
      "cool":"coolSetpoint",
      "hum setpoint":"humidifySetpoint",
      "dehum setpoint":"dehumidifySetpoint",
      "ramp time":"rampMinutes",
      "astro adjust":"astroAdjust",
    }
    const setPointNames = spGetNames(gwType, zoneIndex)
    let spId=setPointNames.indexOf(args.setpointName.toLowerCase())
    cl(spId)
    let colName=setColNameSetpoint(args.columnName)
    let colId=ids[colName]
    let colPid=getParamId2(gwType,"configuration_setpoints",colId)
    let mult=pInd[gwType].config_setpoints[2]
    // cl("-------", colPid, spId, mult)
    if(spId == -1){
      spId = setPointNames.indexOf("")
    }
    let pid=colPid+spId*mult
    let val=cnvNum(dbVals.z[zoneIndex][255][pid])
    cl("------------ current val", val)
    cl("------------ args.val", args.value)
    let newVal=cnvNum(args.value)
    if(colId=="startTimeOfDay"){
      // Support both "7 00" and "7:00" or "07:30" formats
      if (typeof args.value === "string" && args.value.includes(":")) {
        // Parse colon-separated time
        let value = args.value.trim();
        let ampmMatch = value.match(/\s*(a\.?m\.?|p\.?m\.?)\s*$/i);
        if (ampmMatch) {
          // Remove "am"/"pm"/"a.m."/"p.m." from value and assign to args.unit
          value = value.replace(/\s*(a\.?m\.?|p\.?m\.?)\s*$/i, "").trim();
          // Normalize to "am" or "pm"
          args.unit = ampmMatch[1].replace(/\./g, "").toLowerCase();
        }
        // Parse colon-separated time
        let [h, m] = value.split(":").map(Number);
        if (!isNaN(h) && !isNaN(m)) {
          newVal = h + m / 100;
        }      
  }

      if(newVal>100){newVal/=100}
      let parts=newVal.toString().split(" ");
      if(parts[1]){newVal=+parts[0]+parts[1]/100}
      let newValInt=Math.floor(+newVal)
      let newValFrc=+newVal-newValInt
      switch(args.unit.toLowerCase()){
        case "hours":
          newVal*=60
          break
        case "a.m.":
        case "am":
          newVal=60*newValInt+newValFrc*100
          break
        case "p.m.":
        case "pm":
          newVal=60*(newValInt+12)+newValFrc*100
          break
        default:
          newVal=60*newValInt+newValFrc*100
          break
      }
      newVal=Math.round(newVal)
    }
    // cl(newVal)
    if(colId=="astroAdjust"){
      newVal=["none","sunrise","sunset"].indexOf(args.value.toLowerCase())
      if(newVal<0){newVal=0}
    }
    if(colId=="heatSetpoint" || colId=="coolSetpoint"){
      // if args.unit is Celsius, convert to Fahrenheit
      if(args.unit && args.unit.toLowerCase() == "celsius" || args.unit.toLowerCase() == "c"  ){
        newVal = (newVal * 9/5) + 32; // Convert Celsius to Fahrenheit
      }
    }
    // cl(newVal)
    switch(args.command){
      case "change":
        val=newVal
        break
      case "set":
        val=newVal
        break
      case "increase":
        val+=newVal
        break
      case "decrease":
        val-=newVal
        break
      default:
        val=newVal
    }
    cl("------------ new val",val)
    // save local changes
    // console dbVAls.z
    dbVals.z[zoneIndex][255][pid]=val
    cl(dbVals.z[zoneIndex][255][pid])
    await sendValue(pid,val, gwType, zoneIndex)
    globs.events.publish("newContext")
    // cl(res)

   }
 var undoSetpoint = async (args, gwType, zoneIndex) => {
    let ids = {
        "enable": "enabled",
        "setpoint name": "name",
        "start time": "startTimeOfDay",
        "heat setpoint": "heatSetpoint",
        "cool setpoint": "coolSetpoint",
        "hum setpoint": "humidifySetpoint",
        "dehum setpoint": "dehumidifySetpoint",
        "ramp time": "rampMinutes",
        "astro adjust": "astroAdjust",
    };
    let spId = spGetNames(gwType, zoneIndex).indexOf(args.setpointName.toLowerCase());
    let colName = setColNameSetpoint(args.columnName);
    let colId = ids[colName];
    let colPid = getParamId2(gwType, "configuration_setpoints", colId);
    let mult = pInd[gwType].config_setpoints[2];
    let pid = colPid + spId * mult;
    let val = cnvNum(args.value); // Previous value from last_setpoint_change
    // Apply unit conversions (same as changeSetpoint)
    if (colId == "startTimeOfDay") {
        // Same time parsing logic as changeSetpoint
        if (typeof args.value === "string" && args.value.includes(":")) {
            let value = args.value.trim();
            let ampmMatch = value.match(/\s*(a\.?m\.?|p\.?m\.?)\s*$/i);
            if (ampmMatch) {
                value = value.replace(/\s*(a\.?m\.?|p\.?m\.?)\s*$/i, "").trim();
                args.unit = ampmMatch[1].replace(/\./g, "").toLowerCase();
            }
            let [h, m] = value.split(":").map(Number);
            if (!isNaN(h) && !isNaN(m)) {
                val = h + m / 100;
            }
        }
        if (val > 100) { val /= 100; }
        let parts = val.toString().split(" ");
        if (parts[1]) { val = +parts[0] + parts[1] / 100; }
        let valInt = Math.floor(+val);
        let valFrc = +val - valInt;
        switch (args.unit.toLowerCase()) {
            case "hours":
                val *= 60;
                break;
            case "a.m.":
            case "am":
                val = 60 * valInt + valFrc * 100;
                break;
            case "p.m.":
            case "pm":
                val = 60 * (valInt + 12) + valFrc * 100;
                break;
            default:
                val = 60 * valInt + valFrc * 100;
                break;
        }
        val = Math.round(val);
    }
    if (colId == "astroAdjust") {
        val = ["none", "sunrise", "sunset"].indexOf(args.value.toLowerCase());
        if (val < 0) { val = 0; }
    }
    if (colId == "heatSetpoint" || colId == "coolSetpoint") {
        if (args.unit && (args.unit.toLowerCase() == "celsius" || args.unit.toLowerCase() == "c")) {
            val = (val * 9/5) + 32;
        }
    }
    let res = await sendValue(pid, val, gwType, zoneIndex);
    globs.events.publish("newContext");
    return res;
};
  var getStagePids=(gwType)=>{
      let is800=gwType==800
      var getPidArray=(arr)=>{
        let tab=(is800)?"igCE":"configuration_channel_data"
        return arr.map(id=>{return (id=="")?-1:
          ((is800)?getParamId800:getParamId)(tab,id)})
      }
      let onoIds_800=["","","","","heat2","heat1","normal","cool1","cool2","cool3","cool4",
        "cool5","cool6"]
      let ventIds_800=["","","","","","","","cool1","cool2","cool3","cool4",
        "cool5","cool6"]
      let ventIds=["","","","","","","CD_normal_vent","cool_1","cool_2","cool_3","cool_4",
        "cool_5","cool_6"]
      let ventIds_1900=["","","","","","","normal_onoff","CD_cool_1","CD_cool_2",
        "CD_cool_3","CD_cool_4","CD_cool_5","CD_cool_6"]
      let onoIds=["CD_heat_6","CD_heat_5","CD_heat_4","CD_heat_3","CD_heat_2","CD_heat_1",
      "normal_onoff","CD_cool_1","CD_cool_2","CD_cool_3","CD_cool_4","CD_cool_5","CD_cool_6"]
      if(gwType==1900){
        ventIds=ventIds_1900
      }
      if(is800){
        ventIds=ventIds_800
        onoIds=onoIds_800
      }
      return{
        ventPids:getPidArray(ventIds),
        onoPids:getPidArray(onoIds)
      }
    }
  
  var getTempStages=async(zi)=>{
    // this gets the temp stages data for a zone
    cl("get temp stages", zi)
    let zInfo=(globs.zonesInfo.info.filter(zx=>{
      return(zx.siteId==globs.userData.siteLoaded)&&
      (zx.siteZoneIndex==zi)
    })||[])[0]
    let gwType=+zInfo.gatewayType//+this.getGatewayType(zi)
    let isPearl=gwType==1900
    let is800=gwType==800
    let heatStages=6;
    let coolStages=6;
    let stagePids=getStagePids(gwType)
    let pid=getParamId("configuration_zone_settings","Heat stages")
    if(dbVals.z[zi][255]){
      heatStages=((dbVals.z[zi][255]||{})[pid])||1
      pid=getParamId("configuration_zone_settings","Cool stages")
      coolStages=(+dbVals.z[zi][255][pid])||6
    }else{
      heatStages=1
      coolStages=6
    }
    if(is800){
      heatStages=2
      coolStages=6
    }
    let chans=[]
    var pearlUsed=[],pChans=[]
    if(isPearl){
      pearlUsed=getPearlUsed(zi)
      pChans=Object.keys(pearlUsed).map(k=>{return pearlUsed[k].chInd})
    }
    if(is800){pChans=[...Array(8).keys()]}
    let i2=1
    const channelInfo=globs?.tempStagedChannelInfo||[]
    cl("chaninfo", channelInfo)
    for(let i=0;i<128;i++){
      let ci=channelInfo[i]
//       cl(ci)
      let eqOnOff=constant.EQ_ONOFF
      let eqVent=constant.EQ_VENT
      if(is800){
        eqOnOff=constant.EQ_800_ON_OFF
        eqVent=constant.EQ_800_VENT
      }
      let show=(((!isPearl)&&ci.used)||pChans.includes(i))&&
        ([eqOnOff,eqVent].includes(+ci.channelType))
      show=show&&!(is800&&proportionals800.includes(ci.channelType)&&(i%2))
      if(show){
//         (this.gwType==1900))&&([constant.EQ_ONOFF,constant.EQ_VENT].includes(+ci.channelType))){
//         cl(ci)
        let pids=(ci.channelType==eqOnOff)?stagePids.onoPids:stagePids.ventPids
//         cl(pids)
//         cl(dbVals.z[zi][i])
        let vals=pids.slice(6-heatStages,+coolStages+7)
          .map(id=>{return (id<0)?-1:+(dbVals.z[zi][i][id]||0)})
        chans.push({
          ch:i,
          chId:(isPearl||is800)?1+i:i2++,
          type:ci.channelType,
          name:ci.channelName||"None",
          stages:vals,
          refs:vals.map(v=>{return React.createRef()}),
        })
      }
    }
  }
  var getSaveSetpoints=async(z)=>{
    // let z=this.zuci[0]
    // z is zoneindex
    let tab=pInd[1800].config_setpoints
    let mult=tab[2]
    let setpoints=[]// used for both get and save
    let fields=["name","enabled","startTimeOfDay","astroAdjust","rampMinutes","heatSetpoint","coolSetpoint",
      "humidifySetpoint","dehumidifySetpoint"]
    for(let i=0;i<8;i++){
        let val={}
        fields.forEach(f=>{ if(dbVals.z[z]) {
          let tVal=(dbVals.z[z][255]||{})[mult*i+getParamId("configuration_setpoints",f)]
          // cl({tVal})
          if(f!="name" && f!="enabled"){tVal= tVal ? +tVal : ""}
          if(f=="enabled"){tVal= tVal==1 ? +tVal: 0}
          if(f=="name"){tVal= tVal ? tVal : ""}
          val[f]=tVal
        }})
        setpoints.push(val)
      }//for
      cl(setpoints)
      return setpoints

  }
  var hasGatewayType1800 = (scope = "", id = "", selZone="", selSite="") => {
//       cl("hasGatewayType1800", id, scope, selZone, selSite)
    const zones = globs?.zonesInfo?.info || [];
    if (!zones.length) return false;
  
    switch (scope) {
      case "sites":
      case "site":
        // cl(zones.filter(z => z.siteId === id && z.gatewayType === 1800))
        return zones.some(z => z.siteId === id && z.gatewayType === 1800);
      case "zones":
        // cl(zones.filter(z => z.zoneId === id && z.gatewayType === 1800))
        return zones.some(z => z.zoneId === id && z.gatewayType === 1800);
      case "tanks":
      case"tank":
      case "zone":
        if (selZone) {
          return zones.some(z => z.zoneId === selZone && z.gatewayType === 1800);
        } else if (selSite) {
          return zones.some(z => z.siteId === id && z.gatewayType === 1800);
        }
        // fallthrough to default if neither selZone nor selSite
      default:
        return zones.some(z => z.gatewayType == 1800);
    }
  }
  var isHydroRoot16 = (zoneId) =>{
    const zone = globs?.zonesInfo?.info?.find(z => z.zoneId === zoneId);
    if (!zone) return false;
    if (zone.virtual && zone.virtualType === "hydroroot16") return true;
    const fwZone = globs.gatewaysInfo?.info?.find(g=> g.gatewayId === zone.gatewayId);
    if (!fwZone) return false;
    return fwZone?.gatewaySubType === "HydroR" && isHydrorootFwAtLeast(fwZone?.fwVersion);
    // return false
  }

var appendHydroRootToZones = (globs) => {
  if (!globs?.zonesInfo?.info || !globs?.gatewaysInfo?.info) return

  globs.zonesInfo.info.forEach(zone => {
    const fwZone = globs.gatewaysInfo.info.find(g => g.gatewayId === zone.gatewayId);
    zone.isHydroRoot16 = !!(
      (zone.virtual && zone.virtualType === "hydroroot16") ||
      (fwZone?.gatewaySubType === "HydroR" && isHydrorootFwAtLeast(fwZone?.fwVersion))
    );
  })
}
var arrEq=(a,b)=>{
  return (a.length==b.length) && a.every((val,i) => val==b[i])}

var objEq=(a, b)=>{
  if((a==null)!=(b==null)){return false}
  return Object.keys(a).every(k => a[k]===b[k]);
}

var makeNum=(val)=>{return (isNaN(val))?val:+val}
  
var valInp=(type, newVal, oldVal)=>{
  if (type === "text") {return newVal}

  if(newVal==""){return newVal}
  if (type === "int") {return (/^[0-9]+$/.test(newVal))?+newVal:oldVal}

  if (type === "float") {
    if(newVal=="."){return newVal}
    return (
      /^[0-9]+$/.test(newVal) ||              // "1"
      /^[0-9]+\.[0-9]*$/.test(newVal) ||      // "1." or "1.0"
      /^\.[0-9]+$/.test(newVal)               // ".1"
    )?newVal:oldVal
  }
  return oldVal;
}
 var getTabColInfo=(zoneInfo, tab, col)=>{
    let type=zoneInfo?.gatewayType||1800
    if(type==1900){type=1800}
    if(!pInd[type][tab]){return []}
    return [...pInd[type][tab], pi[type][tab][col]]

  }

var makeCurrentChannelNames=(zoneInfo, zone, unit, chan, getDBParmValue)=>{
  // for AI to get channel info on any page
  let names = [];
  let channelInfo=[]
  let gwType=zoneInfo?.gatewayType||1900
  var cols
  if(gwType==800){
    cols=["channelName", "used", "channelType",
      "humidify", "dehumidify", "coldDehum"]
  }else{
    cols=["channelName", "used", "isAnalog", "channelType",
      "stageDehumidfy1", "stageDehumidfy2", "stageColdDehumidfy", "stageHumidfy"]
  }
  let offsets=[]
  var base, type, ofs
  let tab=(gwType==800)?"igCE":"channels_configuration"
  cols.forEach(c=>{
    [base, type, , , ofs] =
        getTabColInfo(zoneInfo, tab, c);
    offsets.push(ofs)
  })
  var pUsed, chCnt=128
  if(gwType==1900){
    pUsed=getPearlUsed(zone)
    chCnt=pUsed.length
  }

  for (let i = 0 ; i < chCnt ; i++){
    names.push(getDBParmValue(
        zone, unit,
        i, 0, base + offsets[0], type, 0));
    let obj={}
    cols.forEach((c,j)=>{
      obj[c]=getDBParmValue(
          zone, unit,
          i, 0, base + offsets[j], type, 0);
    })
    if(gwType==800){obj.channelType=+obj.channelType+30}// convert to 800 types
    channelInfo.push(obj)
    cl(obj)
  }
  if(gwType==1900){
    pUsed.forEach(pu=>{
      if(!channelInfo[pu.chInd]){channelInfo[pu.chInd]={}}
      channelInfo[pu.chInd].used=true
    })
  }
  if(channelInfo[chan]){
    //note: chanTypeOrig should be stored separately if needed
  }
  return [names, channelInfo];
}

var pearlMappingTypeNames={
  ins:"Inside",
  out:"Outside",
  tmp:"Temperature",
  vlt:"Voltage",
  gn0:"Generic 1-25",
  gn1:"Generic 26-50",
  gn2:"Generic 51-75",
  gn3:"Generic 76-100",
  gn4:"Generic 101-128",
}

export {cl, doGetPost, constant, openWebSocket, sendWebSocketMessage, webSocketTransaction,
  initWebSocket, inputField, loginoutUsa, saveTokens, checkLoggedIn, wsTrans, validEmail,
  logout, eqTypes, getChannelType, readValObjType, getTable, getParmValue,
  getDatapointName, colorSquare, getParmInfo, doGetPostBasic, getHomeDashboard,
  getLinkUrl, removeAClass, addAClass, hasAClass, toggleAClass, getParamId,
  getParamId2,
  tempUnit, lightUnit, bVolUnit, sVolUnit,distUnit,flowUnit,doUnit,
  pressUnit,pctUnit,nulUnit,voltUnit,
  windUnit,nuteUnit,stages,humStages,gmbAddXBoardShorts, sensorIds,chanPosIds,getUId,eqOverrides,makeSiteSensorNames,siteSensorNames,
  saveSession,alarmToSensor,setSensorIdNames,getChannelsInfo,
  loadAddedSensors,initSensorIds,saveBrowserAccess,getWindowResize,loadWsTrans,
  localAccess,cache,getParamId800,makeOpts,getChannelTypeId,getPearlUsed,
  getPearlNumIO,get800Used,getPe,xBoardShorts,allSense,getTzo,getTZIndicator,getDst,updatePearlImage, changeSetpoint,undoSetpoint, getSaveSetpoints, spGetNames,
  hasGatewayType1800, isHydroRoot16,genericTypes,getAuxGraphing,
  chanOvrIds,getDbId,getDbVal,getSensorDeadbandRule,objEq,makeNum,valInp,cl2, appendHydroRootToZones,
  SENSOR_ERR_VAL,GEN_SENSOR_ERR_VAL,isSensorErrVal,isGenSensorPid,pearlMappingTypeNames,
}
